import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CountryService } from "../country.service";
import { AmazingTimePickerService } from "amazing-time-picker";
import { empty } from "rxjs/Observer";
import { error } from "util";
import { EventsService } from "angular4-events";
// import {setTimeout} from "timers";
// import {setTimeout} from "timers";

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr: any;
declare var moment: any;
@Component({
  selector: "app-dispensary-detail",
  templateUrl: "./dispensary-detail.component.html",
  styleUrls: ["./dispensary-detail.component.css"],
})
export class DispensaryDetailComponent implements OnInit {
  id: number;
  private sub: any;
  nao = new Nanobar();
  countryCode: any;
  countryCode2: any;

  btype: any;
  bSecondType: any;
  numChk = false;
  businessType: any = 0;
  businessApp: any;
  businessLogistics: any;
  description: any;
  phone: any;
  phone2: any;
  name: any;
  about: any;
  email: any;
  dob: any;
  address: any;
  addressPre: any;
  btnDisable = false;
  city: any;
  cityPre: any;
  restErrorCode: any;
  zip: any;
  street: any;
  state: any;
  area: any;
  apart: any;
  latitude: any;
  latitudePre: any;
  longitude: any;
  longitudePre: any;
  type: any;
  open_time: any;
  open_time2 = "";
  close_time: any;
  close_time2 = "";
  success: any;
  place: any;
  error_count: any;
  emailChk: any;
  managerName: any;
  managerEmail: any;
  dispensaryImage: any;
  usernameTaken: any;
  nameTakenError: any;
  clearTimeout: any;
  availableNameChkBtn: any;
  detailData: any;
  disableFields = true;
  disableField = true;
  disableFieldsManager = true;
  dispensarySquareImage: any;
  // time variables
  dateObjOpen: any;
  dateObjClose: any;
  milli: any;
  seconds: any;
  minutes: any;
  hours: any;
  staticDate = "2018/05/16";
  dateObjOpenSend: any;
  utcOpen: any;
  afterUtcOpenTime: any;
  openFinalToSend: any;
  finalToSend: any;
  dateObjCloseSend: any;
  utcClose: any;
  afterUtcCloseTime: any;
  closeFinalToSend: any;
  finalToSendClose: any;
  openTimeWithoutChnage: any;
  closeTimeWithoutChnage: any;
  zoneOperator: any;
  gmt_date: any;
  gmt_date2: any;
  user = {
    timezone: "",
  };
  timeZoneText: any;
  timeZoneTextFinal = "";
  timeZoneTextFinalToSend = "";
  addedTimeZone = "";
  aliasName: any;
  // product vars
  productData: any;
  paginatedData: any;
  searchProduct = "";
  btnShowAfterDataLoad = false;
  page = 0;
  last_page: any;
  limit: any;
  // clearTimeout2: any;
  filterValue = "All";
  outletName = "All";
  filterValCount = -1;
  outletID = -1;
  noDataFoundSearch = false;
  // type = 'data';
  productId: any;
  removeSuccess: any;
  removeMsg: any;
  removeProductNameConfirm: any;
  defaultViewToShow = false;
  addStockValue: any;
  // addStockValue1: any;
  variantIdToAddStock: any;
  addStockSuccess: any;
  addStockSuccessMsg: any;
  isWeb: any;
  isMobile: any;
  showLocal: any;
  isLocal: any;
  isDelivery: any;
  isDineIn: any;
  isSelfPickUp: any;
  addAdminName = "";
  addAdminEmail = "";
  adminPassword = "";
  addAdminSuccess: any;
  addAdminMessage: any;
  reinviteSuccess: any;
  resetSuccess: any;
  resetMsg: any;
  dispensaryCategories: any;
  managerRemoveId: any;
  managerRemoveUsername: any;
  adminRemoveSuccess: any;
  bcatData: any;
  dispensarySquareTile: any;
  dispensarySquareCover: any;
  dispensarySquareLogo: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;
  is_delivery_over_availability_distance = false;
  cityListSuccess: any;
  availableCities: any;
  is_city: any;
  cityLimitName: any;
  disableBtn = false;
  stateLimitName: any;
  bannerChk: any;
  squareChk: any;
  tileChk: any;
  coverChk: any;
  logoChk: any;
  open_timeChk = "";
  close_timeChk = "";
  isCartMobile: any;
  isCartWeb: any;
  isOnline: any;
  isCash: any;
  isFullDay = false;
  openTimeChk = "";
  closeTimeChk = "";
  hoursChk: any;
  selectAddress = false;
  onClickDisabled = false;
  btnDisabled = false;
  InventryId: any;
  addInventryObj: any;
  addInventryItem: any;
  addQuantity: any;
  addInventryCost: any;
  addInventryId: any;
  reasonInventryId: any;
  reasonID: any;
  InventryQuantity: any;
  deleteComment = "";
  addCost = 0;
  inventoryAdd: any;
  addInventoryData: any;
  inventorylist: any;
  addRemoveReason: any;
  transferIdFrom: any;
  transferIdTo: any;
  timeObj = [];
  timeObj1 = [];
  dayIndex: any;
  VariatQ = true;
  seoBusiness: any;
  seoBusinessData: any;
  seo_title: any;
  seo_description: any;
  seo_keyword: any;
  disableSeoField = true;
  disableradiusField = true;
  dispensary_id: any;
  platform_fee_object: any;
  platform_fee_categroy_object: any;
  isEditingPlatform = false;
  isEditingLocalDelivery = false;
  isEditingDelivery = false;
  show_availability_distance: any;
  flat_fee: any;
  default_percentage_fee: any;
  minimum_flat_amount: any;
  minimum_percentage_amount: any;
  flat_fee_dine: any;
  default_percentage_fee_dine: any;
  minimum_flat_amount_dine: any;
  minimum_percentage_amount_dine: any;
  flat_fee_self_pickup: any;
  default_percentage_fee_self_pickup: any;
  minimum_flat_amount_self_pickup: any;
  minimum_percentage_amount_self_pickup: any;
  checkbox1: any;
  platformValidationError: any;

  defaultCheck: any = false;

  time = [
    {
      day: "Monday",
      open: "",
      close: "",
      fullday: false,
      index: 0,
      is_update: false,
    },
    {
      day: "Tuesday",
      open: "",
      close: "",
      fullday: false,
      index: 1,
      is_update: false,
    },
    {
      day: "Wednesday",
      open: "",
      close: "",
      fullday: false,
      index: 2,
      is_update: false,
    },
    {
      day: "Thursday",
      open: "",
      close: "",
      fullday: false,
      index: 3,
      is_update: false,
    },
    {
      day: "Friday",
      open: "",
      close: "",
      fullday: false,
      index: 4,
      is_update: false,
    },
    {
      day: "Saturday",
      open: "",
      close: "",
      fullday: false,
      index: 5,
      is_update: false,
    },
    {
      day: "Sunday",
      open: "",
      close: "",
      fullday: false,
      index: 6,
      is_update: false,
    },
  ];
  idvas: any;
  previousData: any;
  firstzone_distance = "Miles";
  first_zone: any;
  last_zone: any;
  FirstZoneCharges: any;
  lastZoneCharges: any;
  overnight: any;
  dayscharges: any;
  freeDeliveryAfter = 0;
  promotionCheck = false;
  taxRate = 0;
  promotionFor: any;
  popUpIndex: any = 0;
  businessCat = [];
  imgSecIndex: any = 0;

  delivery_payment_options = {
    is_cod: false,
    is_online_payment: false,
    is_bank_transfer: false,
    is_mpos: false,
  };

  pickup_payment_options = {
    is_cod: false,
    is_online_payment: false,
    is_bank_transfer: false,
    is_mpos: false,
  };

  dine_in_payment_options = {
    is_cod: false,
    is_online_payment: false,
    is_bank_transfer: false,
    is_mpos: false,
  };
  bank_fee_percentage_customer: any;
  bank_fee_percentage_business: any;
  isCardDisable: boolean = true;
  app_type: number = 0;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private cs: CountryService,
    private atp: AmazingTimePickerService,
    private events: EventsService
  ) {
    this.sub = this.route.params.subscribe((params) => {
      this.id = +params["id"]; // (+) converts string 'id' to a number
      // console.log('this.id', this.id);
    });
    this.idvas = this.events.subscribe("dispensaryId").subscribe((data) => {
      this.id = data.id;
      this.previousData = data;
      this.dispensary_id = this.id;
      this.detailSeoBusiness();

      //Platform

      this.detailPlatformFeeBusinessCategory();

      this.getAddInventoryFunc();
      this.outletDetail();
      // this.inputAddress();
      this.productslist();
      this.getDispensaryCategoryFunction();
      this.getbusinessCategoryFunction();
      this.getPlatformFeeFunction();
    });
  }
  openTimePop(day, index) {
    this.dayIndex = day;
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe((time) => {
      this.time[this.dayIndex.index].is_update = true;
      $("#openTime" + index).val(time);
      this.time[index].open = time;
      if (this.time[index].close !== "") {
        var now = "05/09/2013 " + this.time[index].close;
        var then = "04/09/2013 " + this.time[index].open;
        this.hoursChk = moment
          .utc(
            moment(now, "DD/MM/YYYY HH:mm:ss").diff(
              moment(then, "DD/MM/YYYY HH:mm:ss")
            )
          )
          .format("H");
        if (parseInt(this.hoursChk, 10) > 0) {
          // this.isFullDay = false;
          this.time[this.dayIndex.index].fullday = false;
        }
        if (parseInt(this.hoursChk, 10) === 0) {
          $("#fullTimePop").modal("show");
        }
        if (
          parseInt(this.hoursChk, 10) < 6 &&
          parseInt(this.hoursChk, 10) !== 0
        ) {
          console.log("in 6 hourse diffrence");
          $("#sixHourPop").modal("show");
          // this.isFullDay = false;
          this.time[this.dayIndex.index].fullday = false;
        }
        if (
          parseInt(this.hoursChk, 10) > 18 &&
          parseInt(this.hoursChk, 10) !== 0
        ) {
          console.log("in 18 hours diffrence");
          $("#eighteenhourPop").modal("show");
          // this.isFullDay = false;
          this.time[this.dayIndex.index].fullday = false;
        }
      }
    });
  }
  closeTimePop(day, index) {
    this.dayIndex = day;
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe((time) => {
      this.time[this.dayIndex.index].is_update = true;
      $("#closeTime" + index).val(time);
      this.time[index].close = time;
      if (this.time[index].open !== "") {
        var now = "05/09/2013 " + this.time[index].close;
        var then = "04/09/2013 " + this.time[index].open;
        this.hoursChk = moment
          .utc(
            moment(now, "DD/MM/YYYY HH:mm:ss").diff(
              moment(then, "DD/MM/YYYY HH:mm:ss")
            )
          )
          .format("H");
        if (parseInt(this.hoursChk, 10) > 0) {
          // this.isFullDay = false;
          this.time[this.dayIndex.index].fullday = false;
        }
        if (parseInt(this.hoursChk, 10) === 0) {
          $("#fullTimePop").modal("show");
        }
        if (
          parseInt(this.hoursChk, 10) < 6 &&
          parseInt(this.hoursChk, 10) !== 0
        ) {
          $("#sixHourPop").modal("show");
          // this.isFullDay = false;
          this.time[this.dayIndex.index].fullday = false;
        }
        if (
          parseInt(this.hoursChk, 10) > 18 &&
          parseInt(this.hoursChk, 10) !== 0
        ) {
          console.log("in 18 hours diffrence");
          $("#eighteenhourPop").modal("show");
          // this.isFullDay = false;
          this.time[this.dayIndex.index].fullday = false;
        }
      }
    });
    console.log("time", this.time);
  }
  setFullTimePopShow() {
    $("#fullTimePop").modal("hide");
    $("#setFullTimepop").modal("show");
  }
  clearTimeFunction() {
    $("#openTime" + this.dayIndex.index).val("");
    $("#closeTime" + this.dayIndex.index).val("");
    this.time[this.dayIndex.index].open = "";
    this.time[this.dayIndex.index].close = "";
    this.time[this.dayIndex.index].is_update = true;
  }
  setFullTimeFunction() {
    // this.isFullDay = true;
    this.time[this.dayIndex.index].fullday = true;
    $("#openTime" + this.dayIndex.index).val("");
    $("#closeTime" + this.dayIndex.index).val("");
    this.time[this.dayIndex.index].open = "";
    this.time[this.dayIndex.index].close = "";
    this.time[this.dayIndex.index].is_update = true;
  }
  changeTimezone(timezone) {
    this.user.timezone = timezone;
    // //console.log('this.user.timezone', this.user.timezone);
    setTimeout(() => {
      // this.timeZoneText = document.getElementById('timZoneSlectPickerProfile').innerText;
      this.timeZoneText = document.getElementById(
        "select2-select-container"
      ).innerText;
      // //console.log('a', this.timeZoneText);
    }, 1000);
  }

  timeSelectConfirm() {
    console.log("this.timeZoneTextFinal", this.timeZoneTextFinal);
    // this.timeZoneTextFinal = document.getElementById('timZoneSlectPickerDetail').innerText;
    this.timeZoneTextFinal = document.getElementById(
      "select2-select-container"
    ).innerText;
    console.log("this.timeZoneTextFinal", this.timeZoneTextFinal);
    this.timeZoneTextFinalToSend = this.timeZoneTextFinal.split("GMT")[1];
    this.timeZoneTextFinalToSend = this.timeZoneTextFinalToSend.split(")")[0];
    // console.log('this.timeZoneTextFinal', this.timeZoneTextFinalToSend);
    this.addedTimeZone = this.timeZoneTextFinalToSend;
    $("#timeZonePopDetail").modal("hide");
  }
  tConvert(time) {
    // console.log('time in t convert', time);
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    // console.log('time after convert', time);

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      // console.log('tme',time);
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    // console.log('time final', time);
    return time.join(""); // return adjusted time or original string
  }

  // marketplaceUpdation() {
  //   this.businessMarketplace = true;
  //   this.businessApp = false;
  //   this.businessLogistics = false;
  // }

  // appUpdation() {
  //   this.businessMarketplace = false;
  //   this.businessApp = true;
  //   this.businessLogistics = false;
  // }

  businessTypeUpdate(id) {
    this.businessType = id;
    console.log(this.businessType);
    this.detailPlatformFeeBusiness();
  }

  businessSeo() {
    this.dataService
      .getSeoBusiness(
        window.localStorage.getItem("token"),
        this.dispensary_id,
        this.seo_title,
        this.seo_description,
        this.seo_keyword
      )
      .subscribe(
        (data) => {
          this.seoBusiness = data;
          this.seo_title = this.seoBusiness.seo_title;
          this.seo_description = this.seoBusiness.seo_description;
          this.seo_keyword = this.seoBusiness.seo_keyword;
          this.disableSeoField = true;
          this.detailSeoBusiness();
        },
        (error) => {
          // console.log('error', error);
        }
      );
  }
  // calling api//
  checkradius() {
    //   if(this.checkbox1 === "true"){
    //     this.is_delivery_over_availability_distance= true
    // } else {
    //     this. is_delivery_over_availability_distance =false;
    // }
    let deliveryData = {
      auth_token: localStorage.getItem("token"),
      amount_for_free_delivery: this.freeDeliveryAfter,
      tax_rate: this.taxRate,
      promotion_check: this.promotionCheck,
      tax_and_threshold_check: true,
      dispensary_id: this.dispensary_id,
      zone_level: this.promotionFor,
      is_delivery_over_availability_distance:
        this.is_delivery_over_availability_distance,
      show_availability_distance: this.show_availability_distance,
    };
    this.dataService.updateDeliveryCharges(deliveryData).subscribe(
      (data) => {
        console.log(data);
        if (data["success"] === true) {
          toastr.success("Setting updated successfully");
          this.nao.go(100);
        } else {
          toastr.success("Something went wrong");
          this.nao.go(100);
        }
      },
      (err) => console.log(err)
    );
  }

  //
  detailSeoBusiness() {
    this.dataService
      .getSeoBusinessDetail(
        window.localStorage.getItem("token"),
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          this.seoBusiness = data;
          console.log("hello", this.seoBusiness);
          this.seo_title = this.seoBusiness.seo_title;
          this.seo_description = this.seoBusiness.seo_description;
          this.seo_keyword = this.seoBusiness.seo_keyword;
        },
        (error) => {
          // console.log('error', error);
        }
      );
  }

  //Platform

  validation() {
    // flat_fee:any;
    // default_percentage_fee:any;
    // minimum_flat_amount:any;
    // minimum_percentage_amount:any;

    if ($("#plat_flat_fee_check").prop("checked") === true) {
      if (this.flat_fee < 0) return "*Flat Fee less than 0?";

      // if (this.flat_fee > this.minimum_flat_amount)
      //   return "*Recommended is to keep the Flat Fee less than the Minimum Flat Fee."

      if (this.minimum_flat_amount < 0)
        return "*Minimum order fee for flat charges can be less than 0?";
    }

    if ($("#plat_percentage_fee_check").prop("checked") === true) {
      if (this.default_percentage_fee < 0)
        return "*What is a percentage less than 0?";

      if (this.default_percentage_fee > 100)
        return "*Percentage greater than 100 is good but not really what we need here.";

      if (this.minimum_percentage_amount < 0)
        return "*Minimum order fee for Percentage charges can be less than 0?";
    }

    return "";
  }

  editPlatFormCharges() {
    this.isEditingPlatform = true;
  }

  setPlatformFeeAsDefault(event) {
    if (event.target.checked == true) {
      this.flat_fee_dine = this.flat_fee_self_pickup = this.flat_fee;
      this.default_percentage_fee_dine =
        this.default_percentage_fee_self_pickup = this.default_percentage_fee;
      this.minimum_flat_amount_dine = this.minimum_flat_amount_self_pickup =
        this.minimum_flat_amount;
      this.minimum_percentage_amount_dine =
        this.minimum_percentage_amount_self_pickup =
          this.minimum_percentage_amount;
      this.defaultCheck = true;
    } else {
      this.flat_fee_dine = this.flat_fee_self_pickup = null;
      this.default_percentage_fee_dine =
        this.default_percentage_fee_self_pickup = null;
      this.minimum_flat_amount_dine = this.minimum_flat_amount_self_pickup =
        null;
      this.minimum_percentage_amount_dine =
        this.minimum_percentage_amount_self_pickup = null;
      this.defaultCheck = false;
    }
  }

  savePlatformCharges() {
    // flat_fee_check, minimum_flat_amount, flat_fee, percentage_fee_check, minimum_percentage_amount, default_percentage_fee
    this.platformValidationError = this.validation();

    if (this.platformValidationError == "") {
      // this.isEditingPlatform = false
      this.savePlatformFeeBusiness();
      // this.saveDelivery();
    } else {
    }
  }

  cancelPlatformCharges() {
    this.isEditingPlatform = false;
  }

  savePlatformFeeBusiness() {
    //flat_fee_check, minimum_flat_amount, flat_fee, percentage_fee_check, minimum_percentage_amount, default_percentage_fee

    var flat_fee_check = false;
    var percentage_fee_check = false;
    var flat_fee_check_dine = false;
    var percentage_fee_check_dine = false;
    var flat_fee_check_self_pickup = false;
    var percentage_fee_check_self_pickup = false;

    if ($("#plat_flat_fee_check").prop("checked") === true) {
      flat_fee_check = true;
    } else {
      this.minimum_flat_amount = 0;
      this.flat_fee = 0;
    }

    if ($("#plat_flat_fee_check_dine_in").prop("checked") === true) {
      flat_fee_check_dine = true;
    } else {
      this.minimum_flat_amount_dine = 0;
      this.flat_fee_dine = 0;
    }

    if ($("#plat_flat_fee_check_self_pickup").prop("checked") === true) {
      flat_fee_check_self_pickup = true;
    } else {
      this.minimum_flat_amount_self_pickup = 0;
      this.flat_fee_self_pickup = 0;
    }

    if ($("#plat_percentage_fee_check").prop("checked") === true) {
      percentage_fee_check = true;
    } else {
      this.minimum_percentage_amount = 0;
      this.default_percentage_fee = 0;
    }

    if ($("#plat_percentage_fee_check_dine_in").prop("checked") === true) {
      percentage_fee_check_dine = true;
    } else {
      this.minimum_percentage_amount_dine = 0;
      this.default_percentage_fee_dine = 0;
    }

    if ($("#plat_percentage_fee_check_self_pickup").prop("checked") === true) {
      percentage_fee_check_self_pickup = true;
    } else {
      this.minimum_percentage_amount_self_pickup = 0;
      this.default_percentage_fee_self_pickup = 0;
    }

    this.dataService
      .saveBusinessPlatformDetails(
        window.localStorage.getItem("token"),
        this.dispensary_id,
        flat_fee_check,
        this.minimum_flat_amount,
        this.flat_fee,
        percentage_fee_check,
        this.minimum_percentage_amount,
        this.default_percentage_fee,
        this.flat_fee_dine,
        this.default_percentage_fee_dine,
        this.minimum_flat_amount_dine,
        this.minimum_percentage_amount_dine,
        this.flat_fee_self_pickup,
        this.default_percentage_fee_self_pickup,
        this.minimum_flat_amount_self_pickup,
        this.minimum_percentage_amount_self_pickup,
        flat_fee_check_dine,
        percentage_fee_check_dine,
        flat_fee_check_self_pickup,
        percentage_fee_check_self_pickup,
        this.businessType
      )
      .subscribe(
        (data) => {
          //Platform Fee
          this.isEditingPlatform = false;
          toastr.success("Updated Platform Fee settings.");
        },
        (error) => {
          // console.log('error', error);
          toastr.error(error);
        }
      );
  }

  detailPlatformFeeBusiness() {
    this.dataService
      .getBusinessPlatformDetails(
        window.localStorage.getItem("token"),
        this.dispensary_id,
        this.businessType
      )
      .subscribe(
        (data) => {
          //Platform Fee
          console.log(this.dispensary_id);
          this.platform_fee_object = data;
          if (this.platform_fee_object.flat_fee_check) {
            $("#plat_flat_fee_check").prop("checked", true);
          }
          if (this.platform_fee_object.percentage_fee_check) {
            $("#plat_percentage_fee_check").prop("checked", true);
          }

          if (this.platform_fee_object.dinein_flat_fee_check) {
            $("#plat_flat_fee_check_dine_in").prop("checked", true);
          }
          if (this.platform_fee_object.dinein_percentage_fee_check) {
            $("#plat_percentage_fee_check_dine_in").prop("checked", true);
          }

          if (this.platform_fee_object.pickup_flat_fee_check) {
            $("#plat_flat_fee_check_self_pickup").prop("checked", true);
          }
          if (this.platform_fee_object.pickup_percentage_fee_check) {
            $("#plat_percentage_fee_check_self_pickup").prop("checked", true);
          }

          this.flat_fee = this.platform_fee_object.flat_fee;
          this.default_percentage_fee =
            this.platform_fee_object.default_percentage_fee;
          this.minimum_flat_amount =
            this.platform_fee_object.minimum_flat_amount;
          this.minimum_percentage_amount =
            this.platform_fee_object.minimum_percentage_amount;
          this.flat_fee_dine = this.platform_fee_object.dinein_flat_fee;
          this.default_percentage_fee_dine =
            this.platform_fee_object.dinein_default_percentage_fee;
          this.minimum_flat_amount_dine =
            this.platform_fee_object.dinein_minimum_flat_amount;
          this.minimum_percentage_amount_dine =
            this.platform_fee_object.dinein_minimum_percentage_amount;
          this.flat_fee_self_pickup = this.platform_fee_object.pickup_flat_fee;
          this.default_percentage_fee_self_pickup =
            this.platform_fee_object.pickup_default_percentage_fee;
          this.minimum_flat_amount_self_pickup =
            this.platform_fee_object.pickup_minimum_flat_amount;
          this.minimum_percentage_amount_self_pickup =
            this.platform_fee_object.pickup_minimum_percentage_amount;
          this.app_type = this.platform_fee_object.app_type;
        },
        (error) => {
          // console.log('error', error);
        }
      );
  }

  detailPlatformFeeBusinessCategory() {
    this.dataService
      .getBusinessPlatformDetailsCategory(
        window.localStorage.getItem("token"),
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          //Platform Fee
          this.platform_fee_categroy_object = data;

          for (
            let i = 0;
            i < this.platform_fee_categroy_object.category_list.length;
            i++
          ) {
            if (
              this.platform_fee_categroy_object.category_list[i]
                .default_category_fee_check
            )
              this.platform_fee_categroy_object.category_list[i].selectedValue =
                "default";
            else if (
              this.platform_fee_categroy_object.category_list[i]
                .percentage_category_fee_check
            )
              this.platform_fee_categroy_object.category_list[i].selectedValue =
                "percentage";
            else if (
              this.platform_fee_categroy_object.category_list[i]
                .flat_category_fee_check
            )
              this.platform_fee_categroy_object.category_list[i].selectedValue =
                "flat";
          }
        },
        (error) => {
          // console.log('error', error);
        }
      );
  }

  categoryPlatformValidation(index) {
    var categoryObject = this.platform_fee_categroy_object.category_list[index];
    if (categoryObject.selectedValue === "default") {
      categoryObject.default_category_fee_check = true;
      categoryObject.percentage_category_fee_check = false;
      categoryObject.flat_category_fee_check = false;
      categoryObject.flat_category_fee = 0;
      categoryObject.percentage_category_fee = 0;
    } else if (categoryObject.selectedValue === "percentage") {
      categoryObject.default_category_fee_check = false;
      categoryObject.percentage_category_fee_check = true;
      categoryObject.flat_category_fee_check = false;
      categoryObject.flat_category_fee = 0;

      //categoryObject.percentage_category_fee = 0
      if (
        categoryObject.percentage_category_fee < 0 ||
        categoryObject.percentage_category_fee > 100
      ) {
        return "*Enter a percentage between 0 and 100";
      }
    } else if (categoryObject.selectedValue === "flat") {
      categoryObject.default_category_fee_check = false;
      categoryObject.percentage_category_fee_check = false;
      categoryObject.flat_category_fee_check = true;
      //categoryObject.flat_category_fee = 0
      categoryObject.percentage_category_fee = 0;
      if (categoryObject.flat_category_fee < 0) {
        return "*Flat fee can not be negative.";
      }
    }

    this.platform_fee_categroy_object.category_list[index] = categoryObject;
    return "Updating Platform Fees...";
  }

  saveCategoryPlatformFeeBusiness(index) {
    var data = this.platform_fee_categroy_object.category_list[index];

    this.dataService
      .saveBusinessCategoryPlatformDetails(
        window.localStorage.getItem("token"),
        this.dispensary_id,
        data.id,
        data.flat_category_fee,
        data.percentage_category_fee,
        data.flat_category_fee_check,
        data.percentage_category_fee_check,
        data.default_category_fee_check
      )
      .subscribe(
        (data) => {
          toastr.success("Updated Platform Fee for Category!");
          this.platform_fee_categroy_object.category_list[
            index
          ].validationMessage = "";
        },
        (error) => {
          // console.log('error', error);
          toastr.error(error);
        }
      );
  }

  updatePlatformFeeBusinessCategory(index, category_id) {
    //Edit Category Platform Fee
    this.platform_fee_categroy_object.category_list[index].validationMessage =
      this.categoryPlatformValidation(index);

    if (
      this.platform_fee_categroy_object.category_list[index]
        .validationMessage == "Updating Platform Fees..."
    ) {
      this.saveCategoryPlatformFeeBusiness(index);
    }

    //this.platform_fee_categroy_object.category_list[index].selectedValue;
  }

  outletDetail() {
    var context = this;
    this.businessCat = [
      {
        business_cat_id: "-1",
        product_cat_ids: [],
        business_cat_name: "",
        business_banner_image: "",
        business_profile_image: "",
        business_tile_image: "",
        business_cover_image: "",
        business_website_logo_image: "",
      },
    ];
    // this.nao.go(30);
    this.dataService
      .getOutletsById(
        window.localStorage.getItem("token"),
        this.id,
        this.seo_title,
        this.seo_description,
        this.seo_keyword
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.detailData = data;
          this.name = this.detailData.name;
          this.about = this.detailData.about;
          this.countryCode = this.detailData.country_code;
          if (this.countryCode === "" || this.countryCode === undefined) {
            this.countryCode = "+1";
          }
          // this.detailData = this.detailData.outlet;
          this.phone = this.detailData.phone_number;
          this.phone2 = this.detailData.phone_number;
          this.email = this.detailData.email;
          this.street = this.detailData.street;
          this.isFullDay = this.detailData.full_day;
          this.address = this.detailData.address_line1;
          this.addressPre = this.detailData.address_line1;
          this.city = this.detailData.city;
          this.cityPre = this.detailData.city;
          this.state = this.detailData.state;
          this.zip = this.detailData.zip;
          this.area = this.detailData.area;
          this.apart = this.detailData.apart_no;
          this.latitude = this.detailData.latitude;
          this.latitudePre = this.detailData.latitude;
          this.longitude = this.detailData.longitude;
          this.longitudePre = this.detailData.longitude;
          this.open_time = this.detailData.open_time;
          this.open_timeChk = this.detailData.open_time;
          this.close_time = this.detailData.close_time;
          this.close_timeChk = this.detailData.close_time;
          this.openTimeWithoutChnage = this.detailData.open_time;
          this.closeTimeWithoutChnage = this.detailData.close_time;
          this.managerName = this.detailData.manager_name;
          this.managerEmail = this.detailData.manager_email;
          this.addedTimeZone = this.detailData.time_zone;
          this.isWeb = this.detailData.is_web;
          this.isMobile = this.detailData.is_mobile;
          this.showLocal = this.detailData.is_nation_wide;
          this.isLocal = this.detailData.is_local;
          this.detailData.is_delivery_available = false;
          this.isDelivery = this.detailData.is_delivery_available
            ? this.detailData.is_delivery_available
            : true;
          this.isDineIn = this.detailData.is_dine_in_available;
          this.isSelfPickUp = this.detailData.is_pickup_available;
          this.isCartMobile = this.detailData.show_cart_on_mobile;
          this.isCartWeb = this.detailData.show_cart_on_web;
          this.isCash = this.detailData.payment_through_cash;
          this.isOnline = this.detailData.payment_through_card;
          this.aliasName = this.detailData.alias;
          this.delivery_payment_options =
            this.detailData.delivery_payment_options;
          this.pickup_payment_options = this.detailData.pickup_payment_options;
          this.dine_in_payment_options =
            this.detailData.dine_in_payment_options;
          this.bank_fee_percentage_customer =
            this.detailData.bank_fee_percentage_customer;
          this.bank_fee_percentage_business =
            this.detailData.bank_fee_percentage_business;
          this.isCardFeeDisable();
          if (
            this.detailData.city !== null &&
            this.detailData.city !== "" &&
            this.detailData.address_line1 !== null &&
            this.detailData.address_line1 !== ""
          ) {
            this.selectAddress = true;
            $("#dispencryAddressMain").css("display", "block");
            setTimeout(() => {
              this.callMap();
            }, 1500);
            console.log("in condition");
          } else {
            this.selectAddress = false;
            $("#dispencryAddressMain").css("display", "none");
            console.log("else condition");
          }

          setTimeout(() => {
            $("#bCategory").val(this.detailData.business_category_id);
            if (this.detailData.business_prod_relation.length > 0) {
              this.detailData.business_prod_relation.forEach((element) => {
                let item = {
                  business_cat_id: element.business_cat_id,
                  product_cat_ids: [],
                  business_cat_name: element.business_cat_name,
                  business_banner_image: "",
                  business_profile_image: "",
                  business_tile_image: "",
                  business_cover_image: "",
                  business_website_logo_image: "",
                };
                let obj = {};
                if (element.product_cat_ids.length > 0) {
                  this.dispensaryCategories.forEach((dispElement) => {
                    if (element.product_cat_ids.includes(dispElement.id)) {
                      obj = {
                        category_id: dispElement.id,
                        category_name: dispElement.name,
                        selected: true,
                      };
                    } else {
                      obj = {
                        category_id: dispElement.id,
                        category_name: dispElement.name,
                        selected: false,
                      };
                    }
                    item.product_cat_ids.push(obj);
                  });
                } else {
                  this.dispensaryCategories.forEach((elementCat) => {
                    let obj1 = {
                      category_id: elementCat.id,
                      category_name: elementCat.name,
                      selected: true,
                    };
                    item.product_cat_ids.push(obj1);
                  });
                }
                for (let i = 0; i < this.businessCat.length; i++) {
                  if (this.businessCat[i].business_cat_id == "-1") {
                    this.businessCat.splice(i, 1);
                  }
                }
                this.businessCat.push(item);
              });
              this.getBusinessCategoryImages();
            }

            $("#bSecondCategory").val(
              this.detailData.business_second_category_id
            );
          }, 500);
          if (this.isWeb === true) {
            $("#showWeb").prop("checked", true);
          }
          if (this.isMobile === true) {
            $("#showMobile").prop("checked", true);
          }
          if (this.showLocal === true) {
            $("#showLocal").prop("checked", true);
          }

          if (this.isLocal === true) {
            $("#isLocal").prop("checked", true);
          }
          if (this.isDelivery === true) {
            $("#delivery").prop("checked", true);
          }
          if (this.isDineIn === true) {
            $("#dineIn").prop("checked", true);
          }
          if (this.isSelfPickUp === true) {
            $("#selfPickup").prop("checked", true);
          }
          if (this.isCartMobile === true) {
            $("#showCartMobile").prop("checked", true);
          }
          if (this.isCartWeb === true) {
            $("#showCartWeb").prop("checked", true);
          }
          if (this.isCash === true) {
            $("#cashOnDelivery").prop("checked", true);
          }
          if (this.isOnline === true) {
            $("#onlinePayment").prop("checked", true);
          }
          // this.timeZoneTextFinalToSend = this.detailData.time_zone;
          // $('#setImg').attr('src', this.detailData.image);
          // $('#setImg2').attr('src', this.detailData.square_image);
          // $('#setImgTile').attr('src', this.detailData.square_logo_image);
          this.bannerChk = this.detailData.image;
          this.squareChk = this.detailData.square_image;
          this.tileChk = this.detailData.square_logo_image;
          this.coverChk = this.detailData.cover_image;
          this.logoChk = this.detailData.business_logo_image;
          this.dispensaryImage = this.detailData.image;
          this.dispensarySquareImage = this.detailData.square_image;
          this.dispensarySquareTile = this.detailData.square_logo_image;
          this.dispensarySquareCover = this.detailData.cover_image;
          this.dispensarySquareLogo = this.detailData.business_logo_image;
          var t = this.open_time;
          this.zoneOperator = this.detailData.outlet.time_zone;
          this.user.timezone = this.detailData.outlet.name_time_zone;
          this.timeObj = this.detailData.outlet.time_list;
          this.timeObj1 = this.detailData.outlet.time_list;

          for (var j = 0; j < this.timeObj.length; j++) {
            this.time[j].fullday = this.timeObj[j].fullday;
            if (this.timeObj[j].fullday === false) {
              var timeData = this.convertTimeFunction(
                this.timeObj[j].open,
                this.timeObj[j].close
              );
              this.timeObj[j].open = timeData[0];
              this.timeObj[j].close = timeData[1];
              console.log("this.timeObj", this.timeObj);
            }
          }

          //      default values seting
          if (this.open_timeChk === "") {
            this.open_time = "";
          }
          if (this.close_timeChk === "") {
            this.close_time = "";
          }
        },
        (error) => {
          this.nao.go(100);
          // console.log('error', error);
        }
      );
  }

  isCardFeeDisable() {
    if (
      this.isSelfPickupOnline() ||
      this.isDeliveryPaymentOnline() ||
      this.isDineInOnline()
    ) {
      this.isCardDisable = false;
    } else {
      this.isCardDisable = true;
    }
  }

  isSelfPickupOnline(): boolean {
    return !!(
      this.isSelfPickUp && this.pickup_payment_options.is_online_payment
    );
  }
  isDeliveryPaymentOnline(): boolean {
    return !!(
      this.isDelivery && this.delivery_payment_options.is_online_payment
    );
  }
  isDineInOnline(): boolean {
    return !!(this.isDineIn && this.dine_in_payment_options.is_online_payment);
  }

  getBusinessCategoryImages() {
    let imageDataArr;
    this.nao.go(30);
    this.dataService
      .getBusinessCategoryImages(window.localStorage.getItem("token"), this.id)
      .subscribe(
        (data) => {
          imageDataArr = data["data"];
          console.log(imageDataArr);
          for (let i = 0; i < this.businessCat.length; i++) {
            for (let j = 0; j < imageDataArr.length; j++) {
              if (
                this.businessCat[i].business_cat_id ==
                imageDataArr[j].business_cat_id
              ) {
                this.businessCat[i].business_banner_image =
                  imageDataArr[j].business_banner_image;
                this.businessCat[i].business_profile_image =
                  imageDataArr[j].business_profile_image;
                this.businessCat[i].business_tile_image =
                  imageDataArr[j].business_tile_image;
                this.businessCat[i].business_cover_image =
                  imageDataArr[j].business_cover_image;
                this.businessCat[i].business_website_logo_image =
                  imageDataArr[j].business_website_logo_image;
              } else if (imageDataArr[j].business_cat_id == null) {
                this.businessCat[i].business_banner_image =
                  imageDataArr[j].business_banner_image;
                this.businessCat[i].business_profile_image =
                  imageDataArr[j].business_profile_image;
                this.businessCat[i].business_tile_image =
                  imageDataArr[j].business_tile_image;
                this.businessCat[i].business_cover_image =
                  imageDataArr[j].business_cover_image;
                this.businessCat[i].business_website_logo_image =
                  imageDataArr[j].business_website_logo_image;
              }
            }
          }

          this.nao.go(100);
        },
        (err) => {
          console.log(err);
          this.nao.go(100);
        }
      );
  }

  editLocalDelivery() {
    this.isEditingLocalDelivery = true;
  }

  cancelLocalDelivery() {
    this.isEditingLocalDelivery = false;
  }

  cardFeeChanges(type: "customer" | "business") {
    if (type === "customer") {
      this.bank_fee_percentage_customer = +this.bank_fee_percentage_customer;
      this.bank_fee_percentage_customer > 100
        ? (this.bank_fee_percentage_customer = 100)
        : "";
      this.bank_fee_percentage_business =
        100 - this.bank_fee_percentage_customer;
    } else if ((type = "business")) {
      this.bank_fee_percentage_business = +this.bank_fee_percentage_business;
      this.bank_fee_percentage_business > 100
        ? (this.bank_fee_percentage_business = 100)
        : "";
      this.bank_fee_percentage_customer =
        100 - this.bank_fee_percentage_business;
    }
  }

  saveLocalDeliveryCharges() {
    if (
      this.first_zone === null ||
      this.first_zone === undefined ||
      this.first_zone === ""
    ) {
      toastr.error("Please enter First Zone");
      return;
    }
    if (
      this.last_zone === null ||
      this.last_zone === undefined ||
      this.last_zone === ""
    ) {
      toastr.error("Please enter last Zone");
      return;
    }
    if (
      this.FirstZoneCharges === null ||
      this.FirstZoneCharges === undefined ||
      this.FirstZoneCharges === ""
    ) {
      toastr.error("Please enter First Zone Charges");
      return;
    }
    if (
      this.lastZoneCharges === null ||
      this.lastZoneCharges === undefined ||
      this.lastZoneCharges === ""
    ) {
      toastr.error("Please enter Last Zone Charges");
      return;
    }
    if (
      this.overnight === null ||
      this.overnight === undefined ||
      this.overnight === ""
    ) {
      toastr.error("Please enter Overnight Charges");
      return;
    }
    if (
      this.dayscharges === null ||
      this.dayscharges === undefined ||
      this.dayscharges === ""
    ) {
      toastr.error("Please enter 3-5 days Charges");
      return;
    }
    let deliveryData = {
      auth_token: localStorage.getItem("token"),
      first_zone: this.first_zone,
      firstzone_distance: this.firstzone_distance,
      last_zone: this.last_zone,
      lastzone_distance: this.firstzone_distance,
      firstzone_charges: this.FirstZoneCharges,
      lastzone_charges: this.lastZoneCharges,
      over_night_charges: this.overnight,
      days_charges: this.dayscharges,
      tax_and_threshold_check: false,
      dispensary_id: this.dispensary_id,
    };
    this.nao.go(30);
    this.dataService.updateDeliveryCharges(deliveryData).subscribe(
      (data) => {
        console.log(data);
        if (data["success"] === true) {
          toastr.success("Setting updated successfully");
          this.nao.go(100);
        } else {
          toastr.success("Something went wrong");
          this.nao.go(100);
        }
      },
      (err) => console.log(err)
    );
  }

  editDelivery() {
    this.isEditingDelivery = true;
  }

  cancelDelivery() {
    this.isEditingDelivery = false;
  }

  saveDelivery() {
    if (
      this.promotionCheck === true &&
      (this.freeDeliveryAfter === null ||
        this.freeDeliveryAfter === undefined ||
        this.freeDeliveryAfter < 0)
    ) {
      toastr.error("Please Enter Free Delivery After Amount");
      return;
    }
    if (
      this.taxRate === null ||
      this.taxRate === undefined ||
      this.taxRate < 0
    ) {
      toastr.error("Please Enter Sale Tax");
      return;
    }
    let deliveryData = {
      auth_token: localStorage.getItem("token"),
      amount_for_free_delivery: this.freeDeliveryAfter,
      tax_rate: this.taxRate,
      promotion_check: this.promotionCheck,
      tax_and_threshold_check: true,
      dispensary_id: this.dispensary_id,
      zone_level: this.promotionFor,
      app_type: this.app_type,
    };
    this.nao.go(30);
    this.dataService.freeDeliveryFeeCharges(deliveryData).subscribe(
      (data) => {
        console.log(data);
        if (data["success"] === true) {
          toastr.success("Setting updated successfully");
          this.nao.go(100);
        } else {
          toastr.success("Something went wrong");
          this.nao.go(100);
        }
      },
      (err) => console.log(err)
    );
    console.log("Deliver");
  }

  updatePermotion(value) {
    this.promotionCheck = value;
    if (value === false) {
      this.freeDeliveryAfter = null;
    }
  }

  getPlatformFeeFunction() {
    this.dataService
      .getPlatformChargesForFee(
        localStorage.getItem("token"),
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          let chargesData = data["charges"];
          this.first_zone = chargesData.first_zone;
          this.firstzone_distance = chargesData.firstzone_distance;
          this.last_zone = chargesData.last_zone;
          this.FirstZoneCharges = chargesData.firstzone_charges;
          this.lastZoneCharges = chargesData.lastzone_charges;
          this.overnight = chargesData.over_night_charges;
          this.dayscharges = chargesData.days_charges;
          this.freeDeliveryAfter = chargesData.amount_for_free_delivery;
          this.taxRate = chargesData.tax_rate;
          this.promotionCheck = chargesData.promotion_check;
          this.promotionFor = chargesData.zone_level;
          this.is_delivery_over_availability_distance =
            chargesData.is_delivery_over_availability_distance;
          this.show_availability_distance =
            chargesData.show_availability_distance;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  updateFirstZoneDistance(value) {
    this.firstzone_distance = value;
  }

  preventMinus(e) {
    var inputKeyCode = e.keyCode ? e.keyCode : e.which;
    if (inputKeyCode != null) {
      if (inputKeyCode === 45) e.preventDefault(); //45 is for '-' 
    }
  }

  fineDispensaryName() {
    //this.name = this.name.replace(/\b\w/g, function (l) { return l.toUpperCase() });
    // clearTimeout(this.clearTimeout);
    // this.clearTimeout = setTimeout(() => {
    // this.nao.go(30);
    // this.dataService.availableDispensaryName(window.localStorage.getItem('token'), this.name).subscribe(
    //   (data) => {
    //     this.nao.go(100);
    //     this.usernameTaken = data;
    //     this.nameTakenError = data;
    //     this.usernameTaken = this.usernameTaken.success;
    //     if (this.usernameTaken === false) {
    //       this.nameTakenError = this.nameTakenError.message;
    //       this.btnDisable = true;
    //     } else {
    //       this.nameTakenError = '';
    //       this.btnDisable = false;
    //     }
    //   },
    //   (error) => {
    //     this.nao.go(100);
    //     // console.log('error', error);
    //   }
    // );
    //   }, 1000);
  }
  restrictUserInput($event) {
    $event.preventDefault();
  }
  convertMS(duration) {
    // // console.log('duration', duration);
    (this.milli = (duration % 1000) / 100),
      (this.seconds = (duration / 1000) % 60),
      (this.minutes = (duration / (1000 * 60)) % 60),
      (this.hours = (duration / (1000 * 60 * 60)) % 24);
    this.hours = this.hours < 10 ? "0" + this.hours : this.hours;
    this.minutes = this.minutes < 10 ? "0" + this.minutes : this.minutes;
    this.seconds = this.seconds < 10 ? "0" + this.seconds : this.seconds;
    return Math.floor(this.hours) + ":" + this.minutes + ":" + this.seconds;
  }
  checkedFullDay(event, day) {
    this.dayIndex = day;
    if (event.target.checked) {
      this.time[this.dayIndex.index].fullday = true;
    } else {
      this.time[this.dayIndex.index].fullday = false;
    }
    $("#openTime" + this.dayIndex.index).val("");
    $("#closeTime" + this.dayIndex.index).val("");
    this.time[this.dayIndex.index].open = "";
    this.time[this.dayIndex.index].close = "";
    this.time[this.dayIndex.index].is_update = true;
  }
  editDispansaryFunction() {
    // this.error_count = 0;
    // var phone;
    //  $('.c-label label').css('color', '#3d3e3d');
    //  $('.c-label select').css('border-color', '#ccc');
    //  $('.uploadText').css('color', '#3d3e3d');
    //  $('.c-label input').css('border-color', '#ccc');
    //  $('.c-label textarea').css('border-color', '#ccc');
    //
    // // this.open_time = this.tConvert (this.open_time);
    // // this.close_time = this.tConvert (this.close_time);
    // // // console.log('add time open', this.open_time);
    // // // console.log('add time close', this.close_time);
    // // // console.log('value chk any', this.name);
    //  this.btype =  $('#bCategory').val();
    //  // console.log('this.btype', this.btype);
    // this.city = $('#city').val();
    // this.zip = $('#zip').val();
    // this.state = $('#state').val();
    // this.area = $('#area').val();
    // this.apart = $('#apart').val();
    // this.dob = $('#datepicker').val();
    // this.address = $('#c-address input').val();
    // this.open_time2 = $('#timepicker3').val();
    // this.close_time2 = $('#timepicker4').val();
    // // console.log('open close', this.open_time2, this.close_time2);
    //
    // // this.dispensaryImage = $('#image-cropper').cropit('export');
    // // this.dispensarySquareImage = $('#image-cropper2').cropit('export');
    // // this.dispensarySquareTile = $('#image-cropper-tile').cropit('export');
    // // console.log('test image', this.dispensaryImage);
    // // console.log('square', this.dispensarySquareImage);
    // if (this.dispensaryImage === this.bannerChk) {
    //   this.dispensaryImage = null;
    // }
    // if (this.dispensarySquareImage === this.squareChk) {
    //     this.dispensarySquareImage = null;
    // }
    // if (this.dispensarySquareTile === this.tileChk) {
    //             this.dispensarySquareTile = null;
    // }
    // if (this.name === '' || this.name === undefined) {
    //             $('#c-name label').css('color', '#a10a0d');
    //             $('#c-name input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    //  if (this.btype === '' || this.btype === null || this.btype === 'Select Product type') {
    //    $('#c-btype label').css('color', '#a10a0d');
    //    $('#c-btype select').css('border-color', '#a10a0d');
    //    this.error_count ++;
    //  }
    //  if (this.about === '' || this.about === undefined) {
    //    $('#c-about label').css('color', '#a10a0d');
    //    $('#c-about textarea').css('border-color', '#a10a0d');
    //    this.error_count ++;
    //  }
    // if (this.managerName === '' || this.managerName === undefined) {
    //             $('#m-name label').css('color', '#a10a0d');
    //             $('#m-name input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.phone2 === '' || this.phone2 === undefined ) {
    //             // || this.numChk === true
    //             // $('#c-phone label').css('color', '#a10a0d');
    //             // $('#c-phone input').css('border-color', '#a10a0d');
    //             // this.error_count ++;
    //             phone = this.countryCode + this.phone;
    //             // console.log('this.phone2',this.phone2);
    //             // console.log('this.phone + this.countryCode', this.phone + this.countryCode);
    // } else {
    //           var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    //           phone = '+' + getCode + '' + this.phone2;
    //           // console.log('number', this.phone2);
    // }
    //   this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // if (!this.emailChk.test(this.email) && this.email !== '') {
    //             $('#c-email label').css('color', '#a10a0d');
    //             $('#c-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (!this.emailChk.test(this.managerEmail) && this.managerEmail !== '') {
    //             $('#m-email label').css('color', '#a10a0d');
    //             $('#m-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.address === '' || this.address === undefined) {
    //             $('#c-address label').css('color', '#a10a0d');
    //             $('#c-address input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.city === '' || this.city === undefined) {
    //             $('#c-city label').css('color', '#a10a0d');
    //             $('#c-city input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.zip === '' || this.zip === undefined) {
    //             $('#c-zip label').css('color', '#a10a0d');
    //             $('#c-zip input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.state === '' || this.state === undefined) {
    //             $('#c-state label').css('color', '#a10a0d');
    //             $('#c-state input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //             $('#c-area label').css('color', '#a10a0d');
    //             $('#c-area input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // // if (this.open_time2 !== '' || this.close_time2 !== '') {
    // //   if (this.timeZoneTextFinalToSend !== '') {
    // //   this.timeZoneTextFinalToSend = this.timeZoneTextFinal.split('GMT')[1];
    // //   this.timeZoneTextFinalToSend = this.timeZoneTextFinalToSend.split(')')[0];
    // //   // console.log('this.timeZoneTextFinal', this.timeZoneTextFinalToSend);
    // //   this.addedTimeZone = this.timeZoneTextFinalToSend;
    //   // }
    // // }
    //  if (this.open_time2 === '' || this.open_time2 === undefined) {
    //             this.open_time2 = this.openTimeWithoutChnage;
    // } else {
    //     this.dateObjOpenSend = new Date(this.staticDate + ' ' + this.open_time2 + ' GMT' + this.addedTimeZone);
    //     this.utcOpen = this.dateObjOpenSend.toUTCString();
    //     this.afterUtcOpenTime = new Date(this.utcOpen);
    //     this.openFinalToSend = this.afterUtcOpenTime.getTime();
    //     this.finalToSend = this.convertMS(this.openFinalToSend);
    //     this.open_time2 = this.finalToSend;
    //     // console.log('time', this.open_time2);
    // }
    // if (this.close_time2 === '' || this.close_time2 === undefined) {
    //             this.close_time2 = this.closeTimeWithoutChnage;
    // } else {
    //     this.dateObjCloseSend = new Date(this.staticDate + ' ' + this.close_time2 + ' GMT' + this.addedTimeZone);
    //     this.utcClose = this.dateObjCloseSend.toUTCString();
    //     this.afterUtcCloseTime = new Date(this.utcClose);
    //     this.closeFinalToSend = this.afterUtcCloseTime.getTime();
    //     this.finalToSendClose = this.convertMS(this.closeFinalToSend);
    //     this.close_time2 = this.finalToSendClose;
    //     // console.log('time', this.close_time2);
    // }
    // if (this.error_count > 0) {
    //   return;
    // }
    // // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    // //   this.phone = '+' + getCode + this.phone;
    // //   // console.log('number', this.phone);
    // this.nao.go(30);

    this.error_count = 0;
    var phone;
    $(".c-label label").css("color", "#3d3e3d");
    $(".uploadText").css("color", "#3d3e3d");
    $(".c-label input").css("border-color", "#ccc");
    $(".c-label textarea").css("border-color", "#ccc");
    $(".c-label select").css("border-color", "#ccc");

    this.city = $("#city").val();
    this.zip = $("#zip").val();
    this.state = $("#state").val();
    this.area = $("#area").val();
    this.apart = $("#apart").val();
    this.dob = $("#datepicker").val();
    this.address = $("#c-address input").val();
    this.open_time2 = $("#timepicker3").val();
    this.close_time2 = $("#timepicker4").val();
    this.btype = $("#bCategory").val();
    // this.bSecondType =  $('#bSecondCategory').val();
    console.log("this.address", this.address);

    if (this.dispensaryImage === this.bannerChk) {
      this.dispensaryImage = null;
    }
    if (this.dispensarySquareImage === this.squareChk) {
      this.dispensarySquareImage = null;
    }
    if (this.dispensarySquareTile === this.tileChk) {
      this.dispensarySquareTile = null;
    }
    if (this.dispensarySquareCover === this.coverChk) {
      this.dispensarySquareCover = null;
    }
    if (this.dispensarySquareLogo === this.logoChk) {
      this.dispensarySquareLogo = null;
    }
    // if (this.name === '' || this.name === undefined) {
    //             $('#c-name label').css('color', '#a10a0d');
    //             $('#c-name input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.btype === '' || this.btype === null || this.btype === 'Select Product type') {
    //    $('#c-btype label').css('color', '#a10a0d');
    //    $('#c-btype select').css('border-color', '#a10a0d');
    //    this.error_count ++;
    //  }
    //  if (this.about === '' || this.about === undefined) {
    //    $('#c-about label').css('color', '#a10a0d');
    //    $('#c-about textarea').css('border-color', '#a10a0d');
    //    this.error_count ++;
    //  }
    // if (this.managerName === '' || this.managerName === undefined) {
    //             $('#m-name label').css('color', '#a10a0d');
    //             $('#m-name input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.phone2 === '' || this.phone2 === undefined || this.numChk === true) {
    //             // $('#c-phone label').css('color', '#a10a0d');
    //             // $('#c-phone input').css('border-color', '#a10a0d');
    //             // this.error_count ++;
    //             phone = this.countryCode + this.phone;
    //             //console.log('this.phone2', this.phone2);
    //             //console.log('this.phone + this.countryCode', this.phone + this.countryCode);
    // } else {
    //           var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    //           phone = '+' + getCode + '' + this.phone2;
    //           //console.log('number', this.phone2, getCode);
    // }
    //   this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // if (!this.emailChk.test(this.email) && this.email !== '') {
    //             $('#c-email label').css('color', '#a10a0d');
    //             $('#c-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (!this.emailChk.test(this.managerEmail) && this.managerEmail !== '') {
    //             $('#m-email label').css('color', '#a10a0d');
    //             $('#m-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    //  if ((this.address !== '' || this.address !== undefined) && (this.city === '' || this.city === undefined) && (this.zip === '' || this.zip === undefined) && (this.state === '' || this.state === undefined) && (this.area === '' || this.area === undefined))
    // if (this.address !== '' || this.address !== undefined) {
    //    if (this.address !== '' && this.zip !== '' && this.state !== '' && this.area !== '' ) {
    //
    //    } else {
    //             $('#c-address label').css('color', '#a10a0d');
    //             $('#c-address input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    //             if (this.city === '' || this.city === undefined) {
    //             $('#c-city label').css('color', '#a10a0d');
    //             $('#c-city input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.zip === '' || this.zip === undefined) {
    //             $('#c-zip label').css('color', '#a10a0d');
    //             $('#c-zip input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.state === '' || this.state === undefined) {
    //             $('#c-state label').css('color', '#a10a0d');
    //             $('#c-state input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //             $('#c-area label').css('color', '#a10a0d');
    //             $('#c-area input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // }
    // }
    if (this.open_time2 === "" || this.open_time2 === undefined) {
      this.open_time2 = this.openTimeWithoutChnage;
      // $('#c-openTime label').css('color', '#a10a0d');
      // $('#c-openTime input').css('border-color', '#a10a0d');
      // this.error_count ++;
    } else {
      if (this.addedTimeZone === "" || this.addedTimeZone === undefined) {
        toastr.error("Please select a timezone");
        return;
      } else {
        this.dateObjOpenSend = new Date(
          this.staticDate + " " + this.open_time2 + " GMT" + this.addedTimeZone
        );
        this.utcOpen = this.dateObjOpenSend.toUTCString();
        this.afterUtcOpenTime = new Date(this.utcOpen);
        this.openFinalToSend = this.afterUtcOpenTime.getTime();
        this.finalToSend = this.convertMS(this.openFinalToSend);
        this.open_time2 = this.finalToSend;
      }
      // //console.log('time', this.open_time2);
    }
    if (
      this.phone2 === "" ||
      this.phone2 === undefined ||
      this.numChk === true
    ) {
      // $('#c-phone label').css('color', '#a10a0d');
      // $('#c-phone input').css('border-color', '#a10a0d');
      // this.error_count ++;
      // phone = this.countryCode + this.phone;
      // console.log('this.phone2', this.phone2);
      // console.log('this.phone + this.countryCode', this.phone + this.countryCode);
      phone = null;
    } else {
      var getCode = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
      phone = "+" + getCode + "" + this.phone2;
      // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
      // phone = '+' + getCode + '' + this.phone2;
      // console.log('number', this.phone2, getCode);
    }

    if (this.addressPre === "" && this.cityPre === "") {
      console.log("1st enter");
      if (this.address !== "") {
        if (this.zip === "" || this.zip === undefined) {
          $("#c-zip label").css("color", "#a10a0d");
          $("#c-zip input").css("border-color", "#a10a0d");
          this.error_count++;
        }
        // if (this.state === '' || this.state === undefined) {
        //   $('#c-state label').css('color', '#a10a0d');
        //   $('#c-state input').css('border-color', '#a10a0d');
        //   this.error_count ++;
        // }
        // if (this.area === '' || this.area === undefined) {
        //   $('#c-area label').css('color', '#a10a0d');
        //   $('#c-area input').css('border-color', '#a10a0d');
        //   this.error_count ++;
        // }
        if (this.city === "" || this.city === undefined) {
          $("#c-city label").css("color", "#a10a0d");
          $("#c-city input").css("border-color", "#a10a0d");
          this.error_count++;
        }
        if (this.address === "" || this.address === undefined) {
          $("#c-address label").css("color", "#a10a0d");
          $("#c-address input").css("border-color", "#a10a0d");
          this.error_count++;
        }
      }
    }
    if (this.addressPre !== "" && this.cityPre !== "") {
      console.log("1st enter");
      if (this.zip === "" || this.zip === undefined) {
        $("#c-zip label").css("color", "#a10a0d");
        $("#c-zip input").css("border-color", "#a10a0d");
        this.error_count++;
      }
      // if (this.state === '' || this.state === undefined) {
      //   $('#c-state label').css('color', '#a10a0d');
      //   $('#c-state input').css('border-color', '#a10a0d');
      //   this.error_count ++;
      // }
      // if (this.area === '' || this.area === undefined) {
      //   $('#c-area label').css('color', '#a10a0d');
      //   $('#c-area input').css('border-color', '#a10a0d');
      //   this.error_count ++;
      // }
      if (this.city === "" || this.city === undefined) {
        $("#c-city label").css("color", "#a10a0d");
        $("#c-city input").css("border-color", "#a10a0d");
        this.error_count++;
      }
      if (this.address === "" || this.address === undefined) {
        $("#c-address label").css("color", "#a10a0d");
        $("#c-address input").css("border-color", "#a10a0d");
        this.error_count++;
      }
    }

    for (var i = 0; i < this.time.length; i++) {
      if (this.time[i].is_update === true) {
        if (this.time[i].fullday === false) {
          console.log(this.time[i].open, this.timeObj1[i].open);
          if (this.time[i].open === "" && this.timeObj1[i].open === "") {
            toastr.error("Please select " + this.time[i].day + " timing");
            return;
          }
          if (this.time[i].close === "" && this.timeObj1[i].close === "") {
            toastr.error("Please select " + this.time[i].day + " timing");
            return;
          }
          if (this.time[i].open === "" && this.time[i].close === "") {
            toastr.error("Please select " + this.time[i].day + " timing");
            return;
          }
        }
      }
    }
    this.timeZoneTextFinal = document.getElementById(
      "select2-select-container"
    ).innerText;
    if (this.timeZoneTextFinal === "") {
      toastr.error("Please select a time zone");
      return;
    }

    this.timeZoneTextFinalToSend = this.timeZoneTextFinal.split("GMT")[1];
    this.timeZoneTextFinalToSend = this.timeZoneTextFinalToSend.split(")")[0];
    this.addedTimeZone = this.timeZoneTextFinalToSend;
    if (this.addedTimeZone === "") {
      toastr.error("Please select a time zone");
      return;
    }
    for (var j = 0; j < this.time.length; j++) {
      if (this.time[j].fullday === false && this.time[j].open !== "") {
        this.dateObjOpen = new Date(
          this.staticDate +
            " " +
            this.time[j].open +
            " GMT" +
            this.addedTimeZone
        );
        this.utcOpen = this.dateObjOpen.toUTCString();
        this.afterUtcOpenTime = new Date(this.utcOpen);
        this.openFinalToSend = this.afterUtcOpenTime.getTime();
        this.time[j].open = this.convertMS(this.openFinalToSend);
      }
      if (this.time[j].fullday === false && this.time[j].close !== "") {
        this.dateObjClose = new Date(
          this.staticDate +
            " " +
            this.time[j].close +
            " GMT" +
            this.addedTimeZone
        );
        this.utcClose = this.dateObjClose.toUTCString();
        this.afterUtcCloseTime = new Date(this.utcClose);
        this.closeFinalToSend = this.afterUtcCloseTime.getTime();
        this.time[j].close = this.convertMS(this.closeFinalToSend);
      }
    }

    if (this.error_count > 0) {
      return;
    }

    // if (this.address !== '' || this.address !== undefined) {
    //   if (this.address !== this.addressPre) {
    //       if (this.latitude === this.latitudePre && this.longitude === this.longitudePre ) {
    //         toastr.error('Please Update the address & select it from Google suggestions for accuracy');
    //         return;
    //       }
    //
    //     }
    //  }
    // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    //   this.phone = '+' + getCode + this.phone;
    this.nao.go(30);
    var outlet_type = -1;

    this.btnDisable = true;
    this.dataService
      .editDispansary(
        window.localStorage.getItem("token"),
        this.name,
        this.btype,
        this.about,
        phone,
        this.email,
        this.dispensaryImage,
        this.address,
        this.street,
        this.city,
        this.zip,
        this.state,
        this.area,
        this.apart,
        this.managerName,
        this.managerEmail,
        this.dispensarySquareImage,
        this.dispensarySquareTile,
        this.dispensarySquareCover,
        this.dispensarySquareLogo,
        this.latitude,
        this.longitude,
        this.id,
        this.addedTimeZone,
        outlet_type,
        this.time,
        this.user.timezone,
        this.seo_title,
        this.seo_description,
        this.seo_keyword,
        this.businessCat
      )
      .subscribe(
        (data) => {
          // console.log('outlet data');
          this.nao.go(100);
          this.success = data;
          this.restErrorCode = data;
          this.restErrorCode = this.restErrorCode.rest_error_code;
          this.success = this.success.success;
          if (this.restErrorCode === 1) {
            toastr.error("Something went wrong");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 2) {
            toastr.error("Please login again");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 3) {
            toastr.error("Customer already exists");
            this.btnDisable = false;
          }
          if (this.success === true) {
            this.btnDisable = false;
            // this.router.navigate(['dispensaries']);
            this.editClose();
            toastr.success("Successfully updated");
          }
          // if (this.success === false)   if (this.success === true) {
          //   this.btnDisable = false;
          //   this.editClose();
          //   // window.localStorage.setItem('dispensaryImage', this.bannerImg);
          //   // this.events.publish('dispensaryImageUpdate', this.bannerImg);
          //   toastr.success('Successfully updated');
          //   this.time = [
          //     {'day': 'Monday', 'open': '', 'close': '', 'fullday': false, 'index': 0, 'is_update': false},
          //     {'day': 'Tuesday', 'open': '', 'close': '', 'fullday': false, 'index': 1, 'is_update': false},
          //     {'day': 'Wednesday', 'open': '', 'close': '', 'fullday': false, 'index': 2, 'is_update': false},
          //     {'day': 'Thursday', 'open': '', 'close': '', 'fullday': false, 'index': 3, 'is_update': false},
          //     {'day': 'Friday', 'open': '', 'close': '', 'fullday': false, 'index': 4, 'is_update': false},
          //     {'day': 'Saturday', 'open': '', 'close': '', 'fullday': false, 'index': 5, 'is_update': false},
          //     {'day': 'Sunday', 'open': '', 'close': '', 'fullday': false, 'index': 6, 'is_update': false},
          //   ];
          //   for ( var l = 0; l < this.time.length; l++ ) {
          //     $('#openTime' + l).val('');
          //     $('#closeTime' + l).val('');
          //   }

          // }
        },
        (error) => {
          this.nao.go(100);
          this.btnDisable = false;
          // console.log('error', error);
        }
      );
  }
  // inputAddress() {
  //    var context = this;
  //    const input = document.getElementById('searchTextField');
  //
  //    const searchBox = new google.maps.places.Autocomplete(input);
  //    searchBox.addListener('place_changed', function() {
  //
  //      // console.log('place changed');
  //      context.place = searchBox.getPlace();
  //      // console.log('address', context.place);
  //      context.addressDetail();
  //    });
  //  }
  addressDetail() {
    this.street = "";
    $("#state").val("");
    let cityVal = "";
    let cityZip = "";
    // console.log('chk address detail', this.place);
    for (var i = 0; i < this.placeDetailData.length; i++) {
      for (var j = 0; j < this.placeDetailData[i].types.length; j++) {
        if (
          this.placeDetailData[i].types[j] === "administrative_area_level_2"
        ) {
          // this.city = this.placeDetailData[i].long_name;
          // // console.log('city', this.city);
          $("#city").val(this.placeDetailData[i].long_name);
          cityVal = this.placeDetailData[i].long_name;
        } else if (this.placeDetailData[i].types[j] === "locality") {
          $("#city").val(this.placeDetailData[i].long_name);
          cityVal = this.placeDetailData[i].long_name;
        }
        // if (this.placeDetailData[i].types[j] === 'locality') {
        //   this.city = this.placeDetailData[i].long_name;
        //   console.log('city', this.city);
        //   $('#city').val(this.placeDetailData[i].long_name);
        //   cityVal = this.placeDetailData[i].long_name;
        // }
        if (this.placeDetailData[i].types[j] === "street_number") {
          this.street = this.placeDetailData[i].long_name;
          // console.log('street number', this.street);
        }
        if (this.placeDetailData[i].types[j] === "route") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          // console.log('route', this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_2") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          // console.log('sublocality 2', this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_1") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          // console.log('sublocality 1', this.street);
        }

        if (
          this.placeDetailData[i].types[j] === "administrative_area_level_1"
        ) {
          // this.state = this.placeDetailData[i].long_name;
          $("#state").val(this.placeDetailData[i].short_name);
          this.stateLimitName = this.placeDetailData[i].short_name;
        }

        if (this.placeDetailData[i].types[j] === "country") {
          // this.area = this.placeDetailData[i].long_name;
          $("#area").val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === "postal_code") {
          $("#zip").val(this.placeDetailData[i].long_name);
          cityZip = this.placeDetailData[i].long_name;
        } else {
          $("#zip").val("");
        }
      }
    }
    if (cityVal !== "" && cityZip !== "") {
      this.availableCityList(cityVal, cityZip);
    }
  }

  editSeo() {
    this.disableSeoField = false;
  }

  cancelSeo() {
    this.disableSeoField = true;
    // this.detailSeoBusiness();
  }

  editOutlet() {
    var context = this;
    this.disableFields = false;
    this.callMap();
    $(function () {
      setTimeout(() => {
        $("#phone").intlTelInput({
          // autoFormat: true,
          utilsScript:
            "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss",
          autoPlaceholder: false,
          preferredCountries: context.countryCode,
          preventInvalidNumbers: true,
          preventInvalidDialCodes: true,
          formatOnDisplay: true,
          separateDialCode: false,
        });
        //    New Code for cropper
        setTimeout(() => {
          $(".image-cropper").cropit({
            $preview: $(".cropit-preview"),
            $zoomSlider: $(".cropit-image-zoom-input-banner"),
            allowDragNDrop: true,
            minZoom: "fill",
            initialZoom: "min",
            originalSize: true,
            maxZoom: 20,
            imageBackground: true,
            imageBackgroundBorderWidth: 30,
            smallImage: "allow",
            // freeMove: true
          });
        }, 1500);
        $("#cropit-image-input").change(function () {
          console.log("in image preview");
          if ($(".cropit-image-input").val() !== "") {
            $("#cropperBannerImgPop").modal("show");
          }
        });
        setTimeout(() => {
          $(".image-cropper2").cropit({
            $preview: $(".cropit-preview2"),
            $fileInput: $(".cropit-image-input2"),
            $zoomSlider: $(".cropit-image-zoom-input-logo"),
            allowDragNDrop: true,
            minZoom: "fill",
            initialZoom: "min",
            originalSize: true,
            maxZoom: 20,
            imageBackground: true,
            imageBackgroundBorderWidth: 30,
            smallImage: "allow",
          });
        }, 1500);
        $("#cropit-image-input2").change(function () {
          console.log("in image preview2");
          console.log("", $(".cropit-image-input2").val());
          if ($(".cropit-image-input2").val() !== "") {
            $("#cropperProfileImgPop").modal("show");
          }
        });
        setTimeout(() => {
          $(".image-cropper-tile").cropit({
            $preview: $(".cropit-preview-tile"),
            $fileInput: $(".cropit-image-input-tile"),
            $zoomSlider: $(".cropit-image-zoom-input-tile"),
            allowDragNDrop: true,
            minZoom: "fill",
            initialZoom: "min",
            originalSize: true,
            maxZoom: 20,
            imageBackground: true,
            imageBackgroundBorderWidth: 30,
            smallImage: "allow",
          });
        }, 1500);
        $("#cropit-image-input-tile").change(function () {
          console.log("in image preview2");
          console.log("", $(".cropit-image-input-tile").val());
          if ($(".cropit-image-input-tile").val() !== "") {
            $("#cropperTileImgPop").modal("show");
          }
        });

        setTimeout(() => {
          $(".image-cropper-cover").cropit({
            $preview: $(".cropit-preview-cover"),
            $fileInput: $(".cropit-image-input-cover"),
            $zoomSlider: $(".cropit-image-zoom-input-cover"),
            allowDragNDrop: true,
            minZoom: "fill",
            initialZoom: "min",
            originalSize: true,
            maxZoom: 20,
            imageBackground: true,
            imageBackgroundBorderWidth: 30,
            smallImage: "allow",
          });
        }, 1500);
        $("#cropit-image-input-cover").change(function () {
          console.log("in image cover");
          console.log("", $(".cropit-image-input-cover").val());
          if ($(".cropit-image-input-cover").val() !== "") {
            $("#cropperCoverImgPop").modal("show");
          }
        });

        setTimeout(() => {
          $(".image-cropper-logo").cropit({
            $preview: $(".cropit-preview-logo"),
            $fileInput: $(".cropit-image-input-logo"),
            $zoomSlider: $(".cropit-image-zoom-input-logo"),
            allowDragNDrop: true,
            minZoom: "fill",
            initialZoom: "min",
            originalSize: true,
            maxZoom: 20,
            imageBackground: true,
            imageBackgroundBorderWidth: 30,
            smallImage: "allow",
          });
        }, 1500);
        $("#cropit-image-input-logo").change(function () {
          console.log("in image logo");
          console.log("", $(".cropit-image-input-logo").val());
          if ($(".cropit-image-input-logo").val() !== "") {
            $("#cropperLogoImgPop").modal("show");
          }
        });

        $(".select-image-btn").click(function () {
          console.log("in image preview change button");
          $("#cropit-image-input").click();
        });
        $(".select-image-btn2").click(function () {
          $("#cropit-image-input2").click();
        });
        $(".select-image-btn-tile").click(function () {
          $("#cropit-image-input-tile").click();
        });
        $(".select-image-btn-cover").click(function () {
          $("#cropit-image-input-cover").click();
        });
        $(".select-image-btn-logo").click(function () {
          $("#cropit-image-input-logo").click();
        });

        $(".business-banner-image-btn").click(function () {
          $(".busniess-banner-image").click();
        });
        $(".business-profile-image-btn").click(function () {
          $(".business-profile-image").click();
        });
        $(".business-tile-image-btn").click(function () {
          $(".business-tile-image").click();
        });
        $(".business-cover-image-btn").click(function () {
          $(".business-cover-image").click();
        });
        $(".business-website-logo-image-btn").click(function () {
          $(".busniess-website-logo-image").click();
        });
      }, 2000);
      var countryCode;
      setTimeout(() => {
        $("#phone").val(context.countryCode);
        $(function () {
          // $('#phone').focus();
          // console.log('trigger');
          var e = $.Event("keypress", { which: 13 });
          $("#phone").trigger(e);
        });
      }, 1000);
      $("#phone").change(function () {
        countryCode = $("#phone").intlTelInput(
          "getSelectedCountryData"
        ).dialCode;
        $("#phone").val("+" + countryCode);
      });
    });
  }
  businessBannerImage: any;
  bannerChangeFunction(event, imgSecIndex) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (img) => {
        this.businessCat[imgSecIndex].business_banner_image =
          img.target["result"];
      };
      console.log(this.businessCat);
    }
  }
  profileChangeFunction(event, imgSecIndex) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (img) => {
        this.businessCat[imgSecIndex].business_profile_image =
          img.target["result"];
      };
      console.log(this.businessCat);
    }
  }
  tileChangeFunction(event, imgSecIndex) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (img) => {
        this.businessCat[imgSecIndex].business_tile_image =
          img.target["result"];
      };
      console.log(this.businessCat);
    }
  }
  coverChangeFunction(event, imgSecIndex) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (img) => {
        this.businessCat[imgSecIndex].business_cover_image =
          img.target["result"];
      };
      console.log(this.businessCat);
    }
  }
  websiteLogoChangeFunction(event, imgSecIndex) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (img) => {
        this.businessCat[imgSecIndex].business_website_logo_image =
          img.target["result"];
      };
      console.log(this.businessCat);
    }
  }
  onSaveBusinessCatImages(imgSecIndex) {
    console.log(this.businessCat[imgSecIndex]);
    if (this.businessCat[imgSecIndex].business_banner_image == "") {
      toastr.error("Please Upload Business Banner Image");
    }
    if (this.businessCat[imgSecIndex].business_cover_image == "") {
      toastr.error("Please Upload Business Cover Image");
    }
    if (
      this.businessCat[imgSecIndex].hasOwnProperty.business_profile_image == ""
    ) {
      toastr.error("Please Upload Business Profile Image");
    }
    if (this.businessCat[imgSecIndex].business_tile_image == "") {
      toastr.error("Please Upload Business Tile Image");
    }
    if (this.businessCat[imgSecIndex].business_website_logo_image == "") {
      toastr.error("Please Upload Business Website Logo");
    }
    if (
      this.businessCat[imgSecIndex].business_banner_image != "" &&
      this.businessCat[imgSecIndex].business_cover_image != "" &&
      this.businessCat[imgSecIndex].business_profile_image != "" &&
      this.businessCat[imgSecIndex].business_tile_image != "" &&
      this.businessCat[imgSecIndex].business_website_logo_image != ""
    ) {
      this.nao.go(30);
      this.dataService
        .editBusinessCategoryImages(
          window.localStorage.getItem("token"),
          this.businessCat[imgSecIndex],
          this.id
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            toastr.success("Images uploaded successfully");
            console.log(data);
          },
          (err) => {
            this.nao.go(100);
            console.log(err);
          }
        );
    }
  }
  countryValidation() {
    var code = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    code = "+" + code;
    var val = $("#phoneValue").val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        // // console.log('val.length', val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          // console.log('valid');
          this.numChk = false;
          $("#phoneValue").css("border-color", "#ccc");
        } else {
          // console.log('invalid');
          this.numChk = true;
          $("#phoneValue").css("border-color", "#eb3b3b");
        }
      }
    }
  }
  prevent($event) {
    // console.log('prevent default', $event.keyCode);
    if ($event.keyCode === 8 || $event.keyCode === 46) {
      return;
    }
    if (!($event.keyCode >= 48 && $event.keyCode <= 57)) {
      $event.preventDefault();
      return;
    }
  }
  editClose() {
    this.disableFields = true;
    $(".intl-tel-input").remove();
    this.outletDetail();
  }

  // Product work
  productslist() {
    // this.nao.go(30);
    // console.log('login data');
    this.noDataFoundSearch = false;
    // this.type = 'data';
    this.productData = [];
    this.dataService
      .getProductsList(
        window.localStorage.getItem("token"),
        this.id,
        this.outletID
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);
          // console.log('products data', data);
          this.productData = data;
          if (this.productData.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.productData.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.productData.rest_error_code === 4)
            toastr.error("Doest not exist");
          this.limit = 2;
          this.last_page = this.productData.last_page;
          this.page++;
          this.productData = this.productData.items;
          if (this.productData.length === 0) {
            this.noDataFoundSearch = true;
          }
          if (this.productData.length === 0) {
            this.defaultViewToShow = true;
          }
          this.btnShowAfterDataLoad = true;
        },
        (error) => {
          // this.nao.go(100);
          toastr.error("Some thing went wrong");
          // console.log('error', error);
        }
      );
  }
  getProductListByPageFunction() {
    this.nao.go(30);
    // console.log('login data');
    this.dataService
      .getProductsListByPage(
        window.localStorage.getItem("token"),
        this.page,
        this.id
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.paginatedData = data;
          // this.limit = this.paginatedData.limit;
          this.last_page = this.paginatedData.last_page;
          this.paginatedData = this.paginatedData.items;
          this.page++;
          for (var i = 0; i < this.paginatedData.length; i++) {
            this.productData.push(this.paginatedData[i]);
          }
        },
        (error) => {
          this.nao.go(100);
          // console.log('error', error);
        }
      );
  }
  filterValUpdate(val) {
    if (val === "All") {
      this.filterValue = val;
      this.filterValCount = -1;
      this.filterSearch();
    } else {
      this.filterValue = val.name;
      this.filterValCount = val.id;
      this.filterSearch();
    }
    // if (val === 'Out Of Stock') {
    //   this.filterValCount = 1;
    //   this.filterSearch();
    // }
  }
  outletValUpdate(id, name) {
    this.outletName = name;
    this.outletID = id;
    if (name.length > 20) {
      this.outletName = name.substring(0, 20);
    }
    this.filterSearch();
  }

  filterSearch() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.noDataFoundSearch = false;
      // this.type = 'search';
      this.page = 0;
      this.nao.go(30);
      // console.log('searchProduct', this.searchProduct);
      this.dataService
        .searchProductWithFilter(
          window.localStorage.getItem("token"),
          this.searchProduct,
          this.filterValCount,
          this.id,
          this.outletID
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            this.productData = [];
            this.productData = data;
            this.last_page = this.productData.last_page;
            this.page++;
            this.productData = this.productData.items;
            if (this.productData.length === 0) {
              this.noDataFoundSearch = true;
            }
          },
          (error) => {
            this.nao.go(100);
            // console.log('error', error);
          }
        );
    }, 1000);
  }
  clearSearch() {
    this.searchProduct = "";
    this.filterSearch();
  }
  openPop(id, name) {
    this.productId = id;
    this.removeProductNameConfirm = name;
    $("#productRemovePop").modal("show");
  }
  //add Update Qty in table
  AddInventorylistPopup(variant) {
    this.addInventryObj = variant;
    console.log("variant", variant);
    this.addInventryCost = variant.variant_cost;
    $("#addConformPopup").modal("show");
    $("#addOutletId").val(this.outletID);
    this.addInventryItem = null;
  }

  RemoveInventorylistPopup(variant) {
    this.addInventryObj = variant;
    this.addInventryCost = variant.variant_cost;
    $("#sell1").val(this.outletID);
    $("#deleteConformPopup").modal("show");
    $("#selelectReason").val(-1);
    this.addQuantity = null;
    this.addRemoveReason = null;
  }
  //transfer popup
  TransferInventorylistPopup(variant) {
    this.addInventryObj = variant;
    this.addQuantity = variant.variant_cost;
    this.VariatQ = variant.inventory_count;
    this.transferIdFrom = $("#transferIdFrom").val(-1);
    $("#transferConformPopup").modal("show");
    // this.transferIdFrom = Number(this.transferIdFrom);
    this.transferIdTo = $("#transferIdTo").val(-1);
    // this.transferIdTo = Number(this.transferIdTo);
    this.addQuantity = null;
  }

  //transferDoneButtonFunc
  TransDoneInventoryOutletPopup() {
    this.transferIdFrom = $("#transferIdFrom").val();
    this.transferIdFrom = Number(this.transferIdFrom);
    this.transferIdTo = $("#transferIdTo").val();
    this.transferIdTo = Number(this.transferIdTo);
    if (this.transferIdFrom === -1) {
      toastr.error("Please Select From Outlet");
      return;
    }
    if (this.transferIdTo === -1) {
      toastr.error("Please Select To Outlet");
      return;
    }
    if (this.transferIdFrom === this.transferIdTo) {
      toastr.error("Can not transfer inventory within same outlet");
      return;
    }
    if (this.addQuantity === null || this.addQuantity === undefined) {
      toastr.error("Add Quantity");
      return;
    }

    if (this.addQuantity < 1) {
      toastr.error("Quantity cannot be less then 1");
      return;
    }
    // if( this.transferIdFrom !== null){
    //   // VariatQ
    // }
    var key = 3;
    this.dataService
      .transDispensaryStock(
        window.localStorage.getItem("token"),
        this.addInventryObj.id,
        this.transferIdFrom,
        this.transferIdTo,
        key,
        this.addQuantity,
        this.id
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);
          console.log("products data", data);
          this.addInventoryData = data;
          this.deleteComment = "";
          this.addCost = 0;
          if (this.addInventoryData.success === true) {
            $("#transferConformPopup").modal("hide");
            toastr.success(this.addInventoryData.message);
            // this.page = 0;
            this.productslist();

            // for(var i =0; i < this.productData.length; i++){
            //   for(var j =0; j < this.productData[i].variant.length; j++){
            //     if( this.addInventryObj.id === this.productData[i].variant[j].id){
            //       for( var k =0; k < this.inventoryAdd.length; k++){
            //         if(this.inventoryAdd[k].id === this.transferIdFrom){
            //           this.productData[i].variant[j].inventory_count = this.productData[i].variant[j].inventory_count - this.addQuantity;
            //         }
            //       }
            //     }
            //   }
            // }
          } else {
            // this.btnDisabled = false;
            toastr.error(this.addInventoryData.message);
          }
        },
        (error) => {
          toastr.error("Some thing went wrong");
          console.log("error", error);
        }
      );
  }
  RemoveDoneInventorylistPopup() {
    this.addInventryId = $("#sell1").val();
    this.addQuantity = Number(this.addQuantity);
    this.addInventryId = Number(this.addInventryId);
    this.reasonInventryId = $("#selelectReason").val();
    this.reasonInventryId = Number(this.reasonInventryId);
    this.addQuantity = Number(this.addQuantity);
    console.log(
      "inventryid",
      this.addInventryId,
      "addQuantity",
      this.addQuantity,
      "selectReason",
      this.reasonInventryId,
      "comments",
      this.addRemoveReason
    );
    if (this.addInventryId === -1) {
      toastr.error("Please select Outlet");
      return;
    }
    if (this.reasonInventryId === -1) {
      toastr.error("Please select reason");
      return;
    }

    if (this.addQuantity === null || this.addQuantity === undefined) {
      toastr.error("Add Quantity");
      return;
    }
    if (this.addRemoveReason === undefined || this.addRemoveReason === null) {
      toastr.error("Write any other reason");
      return;
    }
    var key = 2;
    this.dataService
      .deleteDispensaryStock(
        window.localStorage.getItem("token"),
        this.addInventryId,
        this.addQuantity,
        this.id,
        this.addRemoveReason,
        this.reasonInventryId,
        key,
        this.addInventryObj.id
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);
          console.log("products data", data);
          this.addInventoryData = data;
          this.deleteComment = "";
          this.addCost = 0;
          if (this.addInventoryData.success === true) {
            $("#deleteConformPopup").modal("hide");
            toastr.success(this.addInventoryData.message);
            // this.page = 0;
            // this.productslist();
            for (var i = 0; this.productData.length; i++) {
              for (var j = 0; j < this.productData[i].variant.length; j++) {
                if (
                  this.addInventryObj.id === this.productData[i].variant[j].id
                ) {
                  this.productData[i].variant[j].inventory_count =
                    this.productData[i].variant[j].inventory_count -
                    this.addQuantity;
                }
              }
            }
          } else {
            // this.btnDisabled = false;
            toastr.error(this.addInventoryData.message);
          }
        },
        (error) => {
          toastr.error("Some thing went wrong");
          console.log("error", error);
        }
      );
  }

  doneInventoryOutletPopup() {
    this.addInventryId = $("#addOutletId").val();
    this.addInventryId = Number(this.addInventryId);
    console.log(
      "inentryItem",
      this.addInventryItem,
      "inventryCost",
      this.addInventryCost,
      "inventryid",
      this.addInventryId,
      "varientid",
      this.addInventryObj.id
    );
    if (this.addInventryId === -1) {
      toastr.error("Please select Outlet");
      return;
    }
    if (
      this.addInventryCost < 0 ||
      this.addInventryCost === null ||
      this.addInventryCost === undefined
    ) {
      toastr.error("Cost cannot be less than 1");
      return;
    }
    if (this.addInventryItem === undefined || this.addInventryItem < 1) {
      toastr.error("Inventory couldnt be zero or null");
      this.btnDisabled = false;
      return;
    }

    // disid, cost, varid, token, outletid
    var key = 0;
    $("#addConformPopup").modal("hide");
    this.dataService
      .addDispensaryStock(
        window.localStorage.getItem("token"),
        this.addInventryCost,
        this.addInventryId,
        this.id,
        this.addInventryItem,
        key,
        this.addInventryObj.id
      )
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.addInventoryData = data;
          this.deleteComment = "";
          this.addCost = 0;
          if (this.addInventoryData.success === true) {
            toastr.success(this.addInventoryData.message);
            // this.page = 0;
            // this.productslist();
            for (var i = 0; this.productData.length; i++) {
              for (var j = 0; j < this.productData[i].variant.length; j++) {
                if (
                  this.addInventryObj.id === this.productData[i].variant[j].id
                ) {
                  this.productData[i].variant[j].inventory_count =
                    this.productData[i].variant[j].inventory_count +
                    this.addInventryItem;
                }
              }
            }
          } else {
            // this.btnDisabled = false;
            toastr.error(this.addInventoryData.message);
          }
        },
        (error) => {
          toastr.error("Some thing went wrong");
          console.log("error", error);
        }
      );
  }

  // Done PopUp
  // addInventorylist(variant_id, key, quantity) {
  //   this.btnDisabled = true;
  //   console.log(variant_id, key, quantity);
  //   if ( key === 2 && this.deleteComment === '' ) {
  //     toastr.error('Please add your comments');
  //     this.btnDisabled = false;
  //     return;
  //   }
  //   if ( key === 0 && this.addCost < 1 ) {
  //     $('#addQty label').css('color', '#a10a0d');
  //         $('#addQty input').css('border-color', '#a10a0d');
  //     toastr.error('Cost price cannot be " 0 " or less than " 1 "');
  //     this.btnDisabled = false;
  //     return;
  //   }
  //   if ( key === 0 && this.addCost === null || this.addCost === undefined ) {
  //     toastr.error('Please add cost per item');
  //     this.btnDisabled = false;
  //     return;
  //   }
  //   toastr.success('Value added successfully');
  //
  //   // var valChk = $('#' + variant_id).val();
  //
  //   // var val = $('#' + quantity).val();
  //   // console.log('val', val);
  //   // // val = parseInt(val);
  //   // if (val === null || val < 1) {
  //   //   toastr.error('Please enter a value');
  //   //   this.btnDisabled = false;
  //   //   return;
  //   // } else {
  //   //   val = parseInt(val);
  //   // }
  //
  //   // var cost = parseInt(this.addCost);
  //   $('#deleteConformPopup').modal('hide');
  //   $('#addConformPopup').modal('hide');
  //   // this.dataService.addDispensaryStock(window.localStorage.getItem('token'), this.variantIdToAddStock, this.id, this.addStockValue).subscribe(
  //   //   (data) => {
  //   //     // this.nao.go(100);
  //   //     console.log('products data', data);
  //   //     this.addInventoryData = data;
  //   //     this.deleteComment = '';
  //   //     this.addCost = 0;
  //   //     // if (this.addInventoryData.rest_error_code === 1) toastr.error('Some thing went wrong');
  //   //     // if (this.addInventoryData.rest_error_code === 2) toastr.error('Please login again');
  //   //     if (this.addInventoryData.rest_error_code === 4) toastr.error('Doest not exist');
  //   //     if (this.addInventoryData.success === true) {
  //         this.btnDisabled = false;
  //   //       toastr.success(this.addInventoryData.message);
  //   //       this.page = 0;
  //   //       this.inventorylist();
  //   //     } else {
  //         this.btnDisabled = false;
  //   //       toastr.error(this.addInventoryData.message);
  //   //     }
  //   //   },
  //   //   (error) => {
  //       this.btnDisabled = false;
  //   //     // this.nao.go(100);
  //   //     toastr.error('Some thing went wrong');
  //   //     console.log('error', error);
  //   //   }
  //   // );
  // }

  // preventMinus(e) {
  //   console.log('e value', e);
  //   var inputKeyCode = e.keyCode ? e.keyCode : e.which;
  //   if (inputKeyCode != null) {
  //     if (inputKeyCode === 45) e.preventDefault();
  //   }
  // }

  removeProductFunction(id) {
    this.nao.go(30);
    this.dataService
      .removeProduct(window.localStorage.getItem("token"), id, this.id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.removeSuccess = data;
          this.removeMsg = this.removeSuccess.message;
          this.removeSuccess = this.removeSuccess.success;
          if (this.removeSuccess === true) {
            // this.productslist();
            // this.filterSearch();
            for (var i = 0; i < this.productData.length; i++) {
              if (id === this.productData[i].id) {
                this.productData.splice(i, 1);
              }
            }
            $("#productRemovePop").modal("hide");
            toastr.success(this.removeMsg);
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }

  // openPopAddStock(variantId) {
  //   this.variantIdToAddStock = variantId;
  //   this.addStockValue = '';
  //   this.addStockValue1 = '';
  //   // console.log('this.variantIdToAddStock', this.variantIdToAddStock);
  //   $('#addStockPop').modal('show');
  // }
  // addVariantStockfunction() {
  //   if (this.addStockValue === '' || this.addStockValue === undefined) {
  //     $('#addQty label').css('color', '#a10a0d');
  //     $('#addQty input').css('border-color', '#a10a0d');
  //     $('#addCost label').css('color', '#a10a0d');
  //     $('#addCost input').css('border-color', '#a10a0d');
  //     toastr.error('Please add quantity');
  //     return;
  //   }
  //   var value = parseInt(this.addStockValue);
  //
  //   if (value <= 0) {
  //     toastr.error('Quantity can not be zero');
  //     return;
  //   }
  //   if (this.addStockValue1 === '' || this.addStockValue1 === undefined) {
  //     $('#addCost label').css('color', '#a10a0d');
  //     $('#addCost input').css('border-color', '#a10a0d');
  //     $('#addQty label').css('color', '#a10a0d');
  //     $('#addQty input').css('border-color', '#a10a0d');
  //     toastr.error('plz add unit cost');
  //     return;
  //   }
  //   var value = parseInt(this.addStockValue1);
  //
  //   if (value <= 0) {
  //     toastr.error('Unit Cost can not be zero');
  //     return;
  //   }
  //
  //   // if (this.addStockValue1 || this.addStockValue <= 0) {
  //   //   toastr.error('plz add quantity & unit cost');
  //   //   return;
  //   // }
  //
  //   // this.nao.go(30);
  //   this.dataService.addDispensaryStock(window.localStorage.getItem('token'), this.variantIdToAddStock, this.id, this.addStockValue).subscribe(
  //     (data) => {
  //       // this.nao.go(100);
  //       this.addStockSuccess = data;
  //       this.addStockSuccess = this.addStockSuccess.success;
  //       if (this.addStockSuccess === true) {
  //         this.filterSearch();
  //         $('#addStockPop').modal('hide');
  //         toastr.success('Stock Added Successfully');
  //       }
  //     },
  //     (error) => {
  //       // this.nao.go(100);
  //     }
  //   );
  // }

  //   thirdParty() {
  //       $('#showLocal').prop('checked', true);
  //       $('#isLocal').prop('checked', false);
  //       this.isLocal = false;
  //       this.showLocal = true;
  //       this.settingsFunction();
  // }
  //   isLocalChk() {
  //       $('#isLocal').prop('checked', true);
  //       $('#showLocal').prop('checked', false);
  //       this.isLocal = true;
  //       this.showLocal = false;
  //       this.settingsFunction();
  // }

  setBusinessPaymentMethod() {
    this.dataService
      .changeSettingsForProduct(
        window.localStorage.getItem("token"),
        this.id,
        this.isMobile,
        this.isWeb,
        this.showLocal,
        this.isLocal,
        this.isCartMobile,
        this.isCartWeb,
        this.isCash,
        this.isOnline,
        this.isDelivery,
        this.isDineIn,
        this.isSelfPickUp,
        this.delivery_payment_options,
        this.pickup_payment_options,
        this.dine_in_payment_options,
        this.bank_fee_percentage_customer,
        this.bank_fee_percentage_business
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          toastr.success("Settings Updated Successfully");
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }

  settingsFunction() {
    this.nao.go(30);
    if ($("#showMobile").prop("checked") === true) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    if ($("#showWeb").prop("checked") === true) {
      this.isWeb = true;
    } else {
      this.isWeb = false;
    }
    if ($("#cashOnDelivery").prop("checked") === true) {
      this.isCash = true;
    } else {
      this.isCash = false;
    }
    if ($("#showCartWeb").prop("checked") === true) {
      this.isCartWeb = true;
    } else {
      this.isCartWeb = false;
    }
    if ($("#showCartMobile").prop("checked") === true) {
      this.isCartMobile = true;
    } else {
      this.isCartMobile = false;
    }
    if ($("#onlinePayment").prop("checked") === true) {
      this.isOnline = true;
    } else {
      this.isOnline = false;
    }
    if ($("#showLocal").prop("checked") === true) {
      this.showLocal = true;
    } else {
      this.showLocal = false;
    }
    if ($("#isLocal").prop("checked") === true) {
      this.isLocal = true;
    } else {
      this.isLocal = false;
    }
    if ($("#dineIn").prop("checked") === true) {
      this.isDineIn = true;
    } else {
      this.isDineIn = false;
    }
    if ($("#selfPickup").prop("checked") === true) {
      this.isSelfPickUp = true;
    } else {
      this.isSelfPickUp = false;
    }
    this.dataService
      .changeSettingsForProduct(
        window.localStorage.getItem("token"),
        this.id,
        this.isMobile,
        this.isWeb,
        this.showLocal,
        this.isLocal,
        this.isCartMobile,
        this.isCartWeb,
        this.isCash,
        this.isOnline,
        this.isDelivery,
        this.isDineIn,
        this.isSelfPickUp,
        this.delivery_payment_options,
        this.pickup_payment_options,
        this.dine_in_payment_options,
        this.bank_fee_percentage_customer,
        this.bank_fee_percentage_business
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          toastr.success("Settings Updated Successfully");
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }

  adminPopOpen() {
    this.addAdminEmail = "";
    this.adminPassword = "";
    this.addAdminName = "";
    $("#addAdminPop").modal("show");
  }
  addAdminEmailSent() {
    $(".c-label label").css("color", "#3d3e3d");
    $(".c-label input").css("border-color", "#ccc");
    if (this.addAdminName === "") {
      $("#add-admin-name label").css("color", "#a10a0d");
      $("#add-admin-name input").css("border-color", "#a10a0d");
      return;
    }
    this.emailChk =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.emailChk.test(this.addAdminEmail) || this.addAdminEmail === "") {
      $("#add-admin-email label").css("color", "#a10a0d");
      $("#add-admin-email input").css("border-color", "#a10a0d");
      return;
    }
    $("#addAdminFinalPop").modal("show");
  }
  addAdminFunction() {
    this.onClickDisabled = true;
    // console.log('in function add admin');
    var count = 0;
    $(".c-label label").css("color", "#3d3e3d");
    $(".c-label input").css("border-color", "#ccc");
    if (this.adminPassword === "") {
      $("#admin-password label").css("color", "#a10a0d");
      $("#admin-password input").css("border-color", "#a10a0d");
      count++;
    }
    this.emailChk =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.emailChk.test(this.addAdminEmail) || this.addAdminEmail === "") {
      $("#add-admin-email label").css("color", "#a10a0d");
      $("#add-admin-email input").css("border-color", "#a10a0d");
      count++;
    }
    if (count > 0) {
      return;
    }
    this.dataService
      .addAdmin(
        window.localStorage.getItem("token"),
        this.id,
        this.addAdminName,
        this.addAdminEmail,
        this.adminPassword
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.addAdminSuccess = data;
          this.addAdminMessage = this.addAdminSuccess.message;
          this.addAdminSuccess = this.addAdminSuccess.success;
          if (this.addAdminSuccess === true) {
            $("#addAdminPop").modal("hide");
            $("#addAdminFinalPop").modal("hide");
            toastr.success("Admin Created Successfully");
            this.outletDetail();
            this.onClickDisabled = false;
          } else {
            toastr.error(this.addAdminMessage);
            this.onClickDisabled = false;
          }
        },
        (error) => {
          this.nao.go(100);
          this.onClickDisabled = false;
        }
      );
  }
  reinviteFunction(email) {
    this.nao.go(30);
    // console.log('login data');
    this.dataService
      .resendEmailToAdmin(window.localStorage.getItem("token"), this.id, email)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.reinviteSuccess = data;
          this.reinviteSuccess = this.reinviteSuccess.success;
          if (this.reinviteSuccess === true) {
            toastr.success("Invitation has been successfully Sent");
          }
        },
        (error) => {
          this.nao.go(100);
          // console.log('error', error);
        }
      );
  }
  forceResetFunction(alias, username) {
    this.nao.go(30);
    // console.log('login data');
    this.dataService
      .forceReset(window.localStorage.getItem("token"), alias, username)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.resetSuccess = data;
          this.resetMsg = this.resetSuccess.message;
          this.resetSuccess = this.resetSuccess.success;
          if (this.resetSuccess === true) {
            toastr.success(this.resetMsg);
          }
          if (this.resetSuccess === false) {
            toastr.error(this.resetMsg);
          }
        },
        (error) => {
          this.nao.go(100);
          // console.log('error', error);
        }
      );
  }
  getDispensaryCategoryFunction() {
    // this.nao.go(30);
    // console.log('login data');
    this.dataService
      .getDispensaryCategories(window.localStorage.getItem("token"), this.id)
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.dispensaryCategories = data;
          this.dispensaryCategories.forEach((element) => {
            let obj = {
              category_id: element.id,
              category_name: element.name,
              selected: false,
            };
            this.businessCat[0].product_cat_ids.push(obj);
          });
        },
        (error) => {
          // this.nao.go(100);
          // console.log('error', error);
        }
      );
  }
  getAddInventoryFunc() {
    this.dataService
      .getInventory(window.localStorage.getItem("token"), this.id)
      .subscribe(
        (data) => {
          this.inventoryAdd = data;
          this.inventoryAdd = this.inventoryAdd.items;
          console.log("this.inventoryAdd", this.inventoryAdd);
        },
        (error) => {}
      );
  }

  adminRemovePopOpen(id, isName) {
    this.managerRemoveId = id;
    this.managerRemoveUsername = isName;
    $("#removeAdminPop").modal("show");
  }
  removeAdminFunction() {
    this.nao.go(30);
    // console.log('login data');
    this.dataService
      .removeAdmin(
        window.localStorage.getItem("token"),
        this.managerRemoveId,
        this.managerRemoveUsername
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.adminRemoveSuccess = data;
          this.adminRemoveSuccess = this.adminRemoveSuccess.success;
          if (this.adminRemoveSuccess === true) {
            $("#removeAdminPop").modal("hide");
            toastr.success("Dispensary admin successfully archived.");
          }
        },
        (error) => {
          this.nao.go(100);
          // console.log('error', error);
        }
      );
  }
  getbusinessCategoryFunction() {
    // this.nao.go(30);
    this.dataService
      .getBusinessCategory(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          // this.nao.go(100);

          this.bcatData = data;
        },
        (error) => {
          // this.nao.go(100);
          // console.log('error', error);
        }
      );
  }
  functionTogetPlace() {
    if (this.selectAddress === true) {
      return;
    }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
      this.dataService.googleAddress(this.address).subscribe(
        (data) => {
          this.placeSuggestionsData = data;
          this.placeSuggestionsData = this.placeSuggestionsData.predictions;
          // console.log('place google data', this.placeSuggestionsData);
          this.placeDataFound = true;
          if ($(".myDrop").hasClass("open")) {
          } else {
            $(".myDrop").addClass("open");
          }
          // this.addressLoad = false;
          // $('#searchTextField').click();
          // $('#searchTextField').focus();
        },
        (error) => {}
      );
    }, 1000);
  }
  functionTogetPlaceDetail(name, id) {
    this.addressLoad = true;
    this.address = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          // console.log('place google detail data', data);
          this.placeDetailData = data;
          $("#dispencryAddressMain").css("display", "block");
          this.selectAddress = true;
          this.placeDetailData = this.placeDetailData.result;
          this.latitude = this.placeDetailData.geometry.location.lat;
          this.longitude = this.placeDetailData.geometry.location.lng;
          // console.log('this.latitude', this.latitude);
          // console.log('this.longitude', this.longitude);
          this.placeDetailData = this.placeDetailData.address_components;
          console.log(this.placeDetailData);
          this.callMap();
          setTimeout(() => {
            this.addressDetail();
            this.addressLoad = false;
          }, 1000);
        },
        (error) => {}
      );
    }, 1000);
  }
  availableCityList(city, zip) {
    this.cityLimitName = city;
    this.nao.go(30);
    this.dataService
      .availableCityList(window.localStorage.getItem("token"), city, zip)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.cityListSuccess = data;
          if (this.cityListSuccess.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.cityListSuccess.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.cityListSuccess.rest_error_code === 4)
            toastr.error("Doest not exist");
          // this.cityListSuccess = this.cityListSuccess.message;
          this.cityListSuccess = this.cityListSuccess.success;
          if (this.cityListSuccess === false) {
            this.disableBtn = true;
            this.availableCities = data;
            this.availableCities = this.availableCities.city_list;
            // setTimeout(() => { this.chRef.detectChanges(); }, 100);
            setTimeout(() => {
              console.log("availableCities", this.availableCities);
              $("#availableCityPop").modal("show");
            }, 2000);
          } else {
            this.disableBtn = false;
          }
        },
        (error) => {
          this.nao.go(100);
        }
      );
  }
  chkCityAvailability() {
    console.log("in ansdakjdas");
    var zip;
    var city;
    city = $("#city").val();
    zip = $("#zip").val();
    if (city !== "" && zip !== "") {
      this.availableCityList(city, zip);
    }
  }
  clearBusinessImage() {
    $(".cropit-image-input").val("");
  }
  clearLogoImage() {
    $(".cropit-image-input2").val("");
  }
  clearTileImage() {
    $(".cropit-image-input-tile").val("");
  }
  clearCoverImage() {
    $(".cropit-image-input-cover").val("");
  }
  clearLogooImage() {
    $(".cropit-image-input-logo").val("");
  }
  expotyBanner() {
    $(".cropit-image-input").val("");
    this.dispensaryImage = $(".image-cropper").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    // console.log('banner export', this.dispensaryImage);
    $("#cropperBannerImgPop").modal("hide");
  }
  expotyProfile() {
    $(".cropit-image-input2").val("");
    this.dispensarySquareImage = $(".image-cropper2").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    // console.log('banner export', this.dispensarySquareImage);
    $("#cropperProfileImgPop").modal("hide");
  }
  expotyTile() {
    $(".cropit-image-input-tile").val("");
    this.dispensarySquareTile = $(".image-cropper-tile").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    // console.log('banner export', this.dispensarySquareTile);
    $("#cropperTileImgPop").modal("hide");
  }
  expotyCover() {
    $(".cropit-image-input-cover").val("");
    this.dispensarySquareCover = $(".image-cropper-cover").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    // console.log('banner export', this.dispensarySquareCover);
    $("#cropperCoverImgPop").modal("hide");
  }
  expotyLogoo() {
    $(".cropit-image-input-logo").val("");
    this.dispensarySquareLogo = $(".image-cropper-logo").cropit("export", {
      originalSize: true,
      quality: 1,
      type: "image/png",
    });
    // console.log('banner export', this.dispensarySquareCover);
    $("#cropperLogoImgPop").modal("hide");
  }
  callMap() {
    var context = this;
    var map;
    var marker;
    var adr;
    var myLatlng = new google.maps.LatLng(this.latitude, this.longitude);
    var geocoder = new google.maps.Geocoder();
    var infowindow = new google.maps.InfoWindow();
    var mapOptions = {
      zoom: 20,
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      navigationControl: false,
      // mapTypeControl: false,
      // disableDefaultUI: true
    };
    console.log(context.latitude, context.longitude);
    var endImage = {
      url: "assets/pin.png", // url
      scaledSize: new google.maps.Size(20, 32), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(10, 35), // anchor
    };

    map = new google.maps.Map(document.getElementById("myMap"), mapOptions);
    if (this.disableFields === true) {
      marker = new google.maps.Marker({
        map: map,
        position: myLatlng,
        icon: endImage,
      });
    }
    if (this.disableFields === false) {
      marker = new google.maps.Marker({
        map: map,
        position: myLatlng,
        draggable: true,
        icon: endImage,
      });
    }

    if (this.disableFields === false) {
      var drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.MARKER,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ["polygon"],
        },
        polygonOptions: {
          strokeColor: "#000000",
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillColor: "#2D2E54",
          fillOpacity: 0.35,
          editable: true,
        },
      });
      drawingManager.setMap(map);

      geocoder.geocode({ latLng: myLatlng }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            // $('#address').val(results[0].formatted_address);
            // $('#latitude').val(marker.getPosition().lat());
            // $('#longitude').val(marker.getPosition().lng());
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
            context.latitude = marker.getPosition().lat();
            context.longitude = marker.getPosition().lng();
            console.log(context.latitude, context.longitude);
            console.log("results", results);
            // context.getDeliveryAddressDetail(results[0]);
          }
        }
      });

      google.maps.event.addListener(
        drawingManager,
        "overlaycomplete",
        function (event) {
          if (event.type == "polygon") {
            var polygon = event.overlay;
          }
        }
      );

      google.maps.event.addListener(marker, "dragend", function () {
        geocoder.geocode(
          { latLng: marker.getPosition() },
          function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                infowindow.setContent(results[0].formatted_address);
                infowindow.open(map, marker);
                context.latitude = marker.getPosition().lat();
                context.longitude = marker.getPosition().lng();
                // context.addressNew =  results[0].formatted_address;
                console.log(context.latitude, context.longitude);
                console.log("results", results);
                // this.changeRef.detectChanges();
                // context.getDeliveryAddressDetail(results[0]);
              }
            }
          }
        );
      });
    }
  }
  convertTimeFunction(open_time, close_time) {
    var context = this;
    var t = open_time;
    this.zoneOperator = this.detailData.time_zone;
    t = "2012/11/29" + " " + t + " " + "UTC";
    this.dateObjOpen = new Date(t);
    var localTime = this.dateObjOpen.getTime();
    var localOffset = this.dateObjOpen.getTimezoneOffset() * 60000;
    var utc = localTime + localOffset;
    var userTimeZone = this.detailData.time_zone;
    // this.dateObjOpen.toString();
    // timeZone work
    var timFirstZone = userTimeZone.split(":")[0];
    if (this.zoneOperator.toString().includes("+") === true) {
      timFirstZone = userTimeZone.split("+")[1];
    } else {
      timFirstZone = userTimeZone.split("-")[1];
    }
    timFirstZone = parseInt(timFirstZone);
    var timSecondZone = userTimeZone.split(":")[1];
    timSecondZone = parseInt(timSecondZone);
    // var timeZoneSeconds = timFirstZone + (timSecondZone / 60);
    // var myTimeZone = 3600000 *  timeZoneSeconds;
    var convertedTime;
    var timeZoneSeconds;
    var myTimeZone;
    if (this.zoneOperator.toString().includes("+") === true) {
      // this.zoneOperator = '+';
      timeZoneSeconds = timFirstZone + timSecondZone / 60;
      myTimeZone = 3600000 * timeZoneSeconds;
      convertedTime = utc + myTimeZone;
    } else {
      // this.zoneOperator = '-';
      timeZoneSeconds = timFirstZone - timSecondZone / 60;
      myTimeZone = 3600000 * timeZoneSeconds;
      convertedTime = utc - myTimeZone;
    }
    var convertedTimeWithZone = new Date(convertedTime);
    // var gmt_date = this.dateObjOpen;
    this.gmt_date = convertedTimeWithZone;
    this.gmt_date = "" + this.gmt_date;
    var dt = this.gmt_date.split("2012")[1];
    var tim = dt.split(":00 GMT")[0];
    open_time = tim;
    var trimValOpen = open_time;
    trimValOpen = trimValOpen.toString().trim();
    open_time = context.tConvert(trimValOpen);
    // closing time in gmt
    var t2 = close_time;
    t2 = "2012/11/29" + " " + t2 + " " + "UTC";
    this.dateObjClose = new Date(t2);
    var localTime2 = this.dateObjClose.getTime();
    var localOffset2 = this.dateObjClose.getTimezoneOffset() * 60000;
    var utc2 = localTime2 + localOffset2;
    // timeZone work
    var convertedTime2;
    if (this.zoneOperator.toString().includes("+") === true) {
      convertedTime2 = utc2 + myTimeZone;
    } else {
      convertedTime2 = utc2 - myTimeZone;
    }
    // var convertedTime2 = utc2 + myTimeZone;
    var convertedTimeWithZone2 = new Date(convertedTime2);
    // this.dateObjClose.toString();
    // var gmt_date2 = this.dateObjClose;
    this.gmt_date2 = convertedTimeWithZone2;
    this.gmt_date2 = "" + this.gmt_date2;
    var dt2 = this.gmt_date2.split("2012")[1];
    var tim2 = dt2.split(":00 GMT")[0];
    close_time = tim2;
    var trimValClose = close_time;
    trimValClose = trimValClose.toString().trim();
    close_time = context.tConvert(trimValClose);

    var returnedArray = [];
    returnedArray.push(open_time);
    returnedArray.push(close_time);
    return returnedArray;
  }

  resetAddress() {
    this.address = "";
    // this.address_line2 = '';
    this.city = "";
    this.state = "";
    this.zip = "";
    this.area = "";
    this.apart = "";
    this.longitude = "";
    this.latitude = "";
    this.selectAddress = false;
    $("#dispencryAddressMain").css("display", "none");
  }

  goBackToDespensaryListing() {
    $(".intl-tel-input").remove();
    this.disableFields = true;
    var data = {
      id: this.id,
      page: this.previousData.page,
      scroll: this.previousData.scroll,
    };
    this.events.publish("details", data);
    // this.detailSeoBusiness();
  }

  selectProductCategories(i) {
    this.popUpIndex = i;
    setTimeout(() => {
      $("#productCategoriesPop" + this.popUpIndex).modal("show");
    }, 500);
  }

  dispensaryCategoryId(event, disID, ind, popupind) {
    this.businessCat[popupind].product_cat_ids[ind].selected =
      !this.businessCat[popupind].product_cat_ids[ind].selected;
  }

  addAnother(i) {
    let item = {
      business_cat_id: "-1",
      product_cat_ids: [],
      business_cat_name: "",
      business_banner_image: "",
      business_profile_image: "",
      business_tile_image: "",
      business_cover_image: "",
      business_website_logo_image: "",
    };
    this.dispensaryCategories.forEach((element) => {
      console.log(element);

      let obj = {
        category_id: element.id,
        category_name: element.name,
        selected: true,
      };
      item.product_cat_ids.push(obj);
    });
    this.businessCat.push(item);
  }

  prodCatRelation() {
    $("#productCategoriesPop" + this.popUpIndex).modal("hide");
  }

  selectBusinessCat(ind) {
    this.businessCat[ind].business_cat_id = parseInt(
      $("#busProdCategory" + ind).val()
    );
  }

  deleteProdRelation(delIndex) {
    this.businessCat.splice(delIndex, 1);
    console.log(this.businessCat);
  }

  imgSectionIndex(ind) {
    this.imgSecIndex = ind;
  }
  editradius() {
    this.disableradiusField = false;
  }
  cancelradius() {
    this.disableradiusField = true;
    // this.detailSeoBusiness();
  }
  toggleEditable(event) {
    if (event.target.checked) {
      this.is_delivery_over_availability_distance = true;
    } else {
      this.is_delivery_over_availability_distance = false;
    }
  }

  openPlatformPopup() {
    if (this.app_type === 1) {
      $("#1").addClass("active");
    } else {
      $("#0").addClass("active");
    }
    $("#platformFee").modal("show");
  }

  ngOnInit() {
    $(".intl-tel-input").remove();
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dispensary-detail/dispensary-detail.component.ts